export default {
    "accountValidateMsg" : "Account must contain 6 - 30 characters, including letters, digits and symbols (\".\", \"_\", \"@\"). The first character must be digit or letter.",
    "storeSuccess" : "Recharge réussie",
    "editAccountTips" : "Please enter a valid account name",
    "editPwdTips" : "Please enter a valid password",
    "editRepeatPwdTips" : "Please enter your password again",
    "pwdRepeatTips" : "Passwords do not match",
    "changePwdSucc" : "Your password has been changed",
    "bindEmail" : "Lier l\'E-mail",
    "errorVrifyCodeTips" : "verification code error",
    "slectQuessionTips" : "Please select a security question?",
    "answerTips" : "Please enter the answer",
    "twoAnswerTips" : "Please select created security questions and enter the correct answers",
    "realNameValidateTips" : "Real name (4 to 60 characters)",
    "phoneValidateTips" : "Phone Number(6 to 18 digits)",
    "areaSelectTips" : "Please select region",
    "iDCardValidataTips" : "ID Number(1 to 60 digits)",
    "changeProfileSucc" : "Updated info saved",
    "editVrfCodeTips" : "Please enter verify code",
    "securityQuestionTips" : "Veuillez créer des questions de sécurité pour améliorer la sécurité de votre compte. Lorsque vous oubliez votre mot de passe, vous pouvez répondre aux questions pour réinitialiser le mot de passe.",
    "validateQuessionTips" : "Veuillez sélectionner deux questions différentes et les vérifier. Vous pouvez recréer les questions après la vérification.",
    "originPwd" : "Mot de passe original",
    "newPwd" : "Nouveau mot de passe",
    "changePwdSuccess" : "Le mot de passe a changé. Nous vous suggérons de vous reconnecter maintenant pour sauvegarder vos progrès.",
    "accountName" : "Nom du compte",
    "password" : "Veuillez entrer votre mot de passe",
    "repeatPassword" : "Veuillez répéter votre mot de passe",
    "findPwdTips" : "Veuillez saisir le compte dont vous souhaitez récupérer le mot de passe",
    "submit" : "soumettre",
    "send" : "Envoyer",
    "modify" : "Modifier",
    "haveAgree" : "J\'accepte les [Conditions Générales d\'Utilisation] Et La [Politique de Confidentialité]",
    "and" : "et",
    "privacyPolicy" : "Politique de Confidentialité",
    "completeness" : "Progression :",
    "gender" : "Sexe",
    "male" : "Homme",
    "female" : "Femme",
    "birthday" : "Anniversaire",
    "phone" : "Téléphone",
    "region" : "Pays/Région",
    "ID" : "-",
    "accountSetting" : "Paramètres du compte",
    "upgrade" : "Mise à niveau",
    "profile" : "Profil",
    "changePassword" : "Modifier le mot de passe",
    "securityQuestion" : "Questions de sécurité",
    "creatework_headerTitle" : "Create Ticket",
    "mylist_headerTitle" : "My Ticket",
    "bindEmailTips" : "Vérifiez votre adresse e-mail pour améliorer le niveau de sécurité de votre compte. Si vous avez oublié votre mot de passe, nous vous enverrons un courriel à cette adresse.",
    "enterEmailVrfcationTips" : "Veuillez saisir le code de vérification ici.",
    "cancel" : "ANNULER",
    "bindTps" : "Bind your account to play the game on multiple devices!",
    "login" : "Connexion",
    "logout" : "déconnexion",
    "bind" : "Lier le compte",
    "feedback" : "Retour",
    "terms" : "Conditions Générales d\'Utilisation",
    "tips" : "Remarque",
    "debindTips" : "La déliaison peut entraîner une perte de données. Êtes-vous sûr de vouloir délier votre compte ?",
    "debindText" : "Débloquer",
    "guestSwitchTips" : "Compte invité détecté. Après la connexion, les données de votre compte invité seront perdues. Poursuivre ?",
    "register" : "s\'inscrire",
    "realName" : "-",
    "enterEmailTips" : "Veuillez saisir votre e-mail",
    "emailVAlidateMsg" : "invalid email",
    "editEmaileTips" : "Please enter your email address",
    "checkServiceTips" : "Please read Terms of Use and Privacy Policy first.",
    "brithdayValidateTips" : "Enter your birthday",
    "facebookValidateTips" : "Facebook Account (1 to 60 characters)",
    "eritOriginPwdTips" : "Original password",
    "submitSuccess" : "Submitted",
    "rebindEmail" : "Modifier l\'adresse électronique liée",
    "bindEmailSuccess" : "E-mail lié : \$email</br>Veuillez utiliser un e-mail lié pour vérifier. Vous pouvez réinitialiser votre e-mail après la vérification.",
    "reSetSecurityQuessoon" : "Vous avez créé avec succès les questions de sécurité </br></br>Veuillez sélectionner d\'autres questions et vérifier. Vous pouvez recréer les questions après la vérification.",
    "canotModifyTips" : "Les modifications ne sont PAS autorisées au moment de la soumission, confirmer de soumettre ?",
    "rebindEmailTips" : "Votre e-mail est : \$email, veuillez cliquer ici pour obtenir le code de vérification",
    "reGetVrfCode" : "Obtenir le code",
    "findPwdWayTips" : "Veuillez sélectionner l\'une des méthodes suivantes",
    "emailWay" : "Récupération par e-mail de sécurité",
    "emailWayTips" : "Vous recevrez un e-mail de confirmation et vous pourrez ensuite réinitialiser le mot de passe",
    "quessionWay" : "Récupération par questions de sécurité",
    "quessionWayTips" : "Répondez aux questions de sécurité créées, puis réinitialisez le mot de passe",
    "resetPwdBtn" : "Réinitialiser le mot de passe",
    "lastStep" : "Précédent",
    "sendEmailTips" : "Nous vous avons envoyé un courriel à \$email.<br>Veuillez saisir le code de vérification que vous avez reçu ici.",
    "setNewPwdTips" : "Félicitations!<br>L\'identité de l\'utilisateur a été vérifiée. Vous pouvez maintenant réinitialiser votre mot de passe.",
    "termsOfUse" : "Conditions d\'Utilisation",
    "copy_success" : "Copied",
    "creatework_create" : "Ticket",
    "creatework_createHolder" : "Select Type",
    "creatework_title" : "Subject",
    "creatework_titleHolder" : "Please enter a subject",
    "creatework_detail" : "détails",
    "creatework_detailHolder" : "Description must not contain more than 200 characters",
    "creatework_uploadTips" : "Please upload jpg/png files only. Uploaded file must be smaller than 5 MB.",
    "creatework_selectBox_selectTile" : "Type",
    "creatework_goGame" : "Return",
    "creatework_history" : "History",
    "mylist_noYet" : "No record",
    "mywork_solved" : "Problem solved?",
    "mywork_service" : "Rate us",
    "mywork_messageHolder" : "New message",
    "mywork_score" : "Score",
    "mywork_confirm" : "CONFIRM",
    "creatework_selectBox_selectList3" : "Other",
    "creatework_selectBox_selectList2" : "Account",
    "close" : "Close",
    "creatework_gameHolder" : "Select Game",
    "creatework_serverHolder" : "Sélectionnez un serveur",
    "contactService" : "Contacter CS",
    "FAQ" : "FAQ",
    "creatework_game" : "Game:",
    "creatework_server" : "Server:",
    "creatework_role" : "Character:",
    "selectRoleName" : "Select Character",
    "creatework_noRole" : "No character",
    "creatework_noGame" : "Game list is empty",
    "creatework_noServer" : "Server list is empty",
    "termText" : "I agree to {mainHost}",
    "backLogin" : "DECLINE",
    "creatework_roleHolder" : "Access after choosing your character",
    "findPwdFailTips" : "You have not set security questions. Please contact customer service.",
    "payMall" : "Mall",
    "selectPayment" : "montant",
    "plzSelectPayWay" : "sélectionner le canal",
    "gainPlus" : "Bonus",
    "gainMorePlus" : "Add More",
    "gainMostPlus" : "Max",
    "plzSelectPayType" : "Select Payment Method",
    "roleName" : "Character",
    "payWay" : "Payment Channel",
    "plzSelectOtherWay" : "Alternative Payment Channel",
    "payment" : "Amount",
    "compensateTips" : "Surplus will be returned to you in \$gameCode",
    "extaGain" : "Bonus",
    "gameGold" : "In-game Currency",
    "compensate" : "Compensation",
    "payWayPlus" : "Channel Bonus",
    "neddPay" : "Payment",
    "submitOrder" : "Submit",
    "screenshotTips" : "Remarque : prenez une capture d\'écran de votre commande en cas d\'erreur de transaction.",
    "storeFail" : "Failed to recharge",
    "storeFailTips" : "Transaction failed. Please submit order again or contact our customer service.",
    "storeAcceptance" : "Processing",
    "storeSuccessTips" : "La transaction sera effectuée dans 15 minutes.",
    "orderNumber" : "N° de commande",
    "buyProduct" : "Objet de recharge",
    "transactionAmount" : "Amount",
    "failReason" : "Reason",
    "payOntherORder" : "Nouvelle commande",
    "reStore" : "Recharge Again",
    "confirm" : "Confirmer",
    "switch" : "Changer de compte",
    "completeTips" : "Veuillez remplir vos informations personnelles. <marque class=\"yellowMarkColor\">Les informations ne seront plus modifiables</marque>. Si vous essayez de récupérer un compte perdu, il vous sera demandé de fournir des informations personnelles correctes.",
    "creatework_selectBox_selectList0" : "Game Error",
    "creatework_selectBox_selectList1" : "Payment Error",
    "creatework_selectBox_selectList4" : "Translation Error",
    "mywork_solvedText" : "Problem solved",
    "browserPayErrBtnText" : "Payment Error",
    "browserPaySucBtnText" : "Payment completed",
    "browserPayingTips" : "Redirecting to third-party platform.<br/>Can close this page after payment.",
    "price_list_empty" : "No applicable sum",
    "pointCardTips" : "Note: This item only supports \$paymentAmount card",
    "forgetPwd" : "Vous avez oublié votre mot de passe ?",
    "payCenter" : "Recharge Center",
    "willGet" : "You will get",
    "goods" : "objet",
    "discount" : "Bonus",
    "payDiscount" : "Compensation",
    "payDiscountTips" : "Extra points will be converted to Diamonds",
    "hasQuestionPlease" : "If you have any questions, please",
    "pwdValidateMsg" : "Password must contain 6 to 20 characters",
    "payWayPlusC" : "Channel Bonus",
    "fwtk" : "TERMS OF SERVICE",
    "yszc" : "PRIVACY POLICY",
    "exchange" : "Échange de code cadeau",
    "remember" : "se souvenir de mon choix",
    "thirdInfo" : "About Account",
    "thirdInfoContent" : "Please bind your account in the in-game User Center. After that, log in the game using the bound account.",
    "unLink" : "This method is currently not supported",
    "favour" : "Bookmark",
    "goStoreTip" : "Please proceed to the payment page",
    "go" : "Go",
    "otherLogin" : "Other login methods",
    "qrCodeTip" : "Scan the QR code to get started!",
    "favourTip" : "Bookmark the page to play again later!",
    "share" : "Share",
    "landscapeTip" : "Please proceed in portrait mode",
    "leaveTip" : "Exit the game?",
    "selectRole" : "Veuillez choisir un personnage",
    "selectMoney" : "Veuillez choisir un objet",
    "seletGameInfoFirst" : "Please choose game",
    "lowerIE" : "IE version too old",
    "linkTermText" : "I have accepted {mainHost} [Terms of Use] and [Privacy Policy]",
    "download" : "Download",
    "favourAndDownloadTip" : "Bookmark this page to browser or download on PC",
    "payReward" : "Recharge Reward",
    "hasEqualReward" : "Double bonus for both payment methods",
    "payBtnText" : "Payment",
    "storeHoaveReward" : "Recharge Bonus",
    "showMorePayWay" : "More Methods",
    "needPaymentCount" : "Amount",
    "orderDetail" : "Details",
    "selectPayWayPlz" : "Choose payment",
    "countryCode" : "Code pays",
    "deleteaccount_title1" : "Delete Account",
    "deleteaccount_title2" : "Demande de suppression de compte",
    "deleteaccount_step1_1" : "Your account will be frozen for 14 days since the account deletion. After 14 days, your account will be permanently deleted. You will not be able to log in with other social accounts.",
    "deleteaccount_step1_2" : "You may revoke the deletion within the 14 days through the link below:",
    "deleteaccount_step1_3" : "Once deleted, you will not be able to restore your account information. You will not be compensated for any loss caused by account deletion.",
    "deleteaccount_step1_4" : "Are you sure you want to delete your account?",
    "deleteaccount_step2_1" : "Please confirm that you want to delete your account and character.",
    "deleteaccount_step2_2" : "Please type \\&quot;Delete\\&quot; to complete the deletion.",
    "deleteaccount_step3" : "Your account will be deleted in 14 days.",
    "accountrecovery_note" : "Note:",
    "accountrecovery_tips" : "You may only revoke account deletion during the 14-day frozen period.",
    "accountrecovery_Submitted2" : "Revocation submitted. Your account will be restored later.",
    "accountrecovery_Failed" : "Failed",
    "accountrecovery_Failed_1" : "Account status is normal. You may log in.",
    "accountrecovery_Failed_2" : "Character information not found.",
    "accountrecovery_success" : "Account restored",
    "account_normal" : "Account status is normal. No need to restore.",
    "account_unablerestore" : "Account has been deleted. Unable to restore.",
    "accountrecovery_roleHolder" : "Enter  your character name",
    "accountrecovery_headerTitle" : "Revoke Account Deletion",
    "guideTitle" : "Your purchase is not successful. Please contact our customer service.",
    "accountFix" : "Account Recovery",
    "inputAccount" : "Please enter the account name that you wish to recover",
    "applyForAccountFix" : "Account Recovery",
    "nonEnterItem" : "Information to add: Registration Date; Model Number; Device Name; Passport or ID Number, Contact E-mail; Please fill in the blanks",
    "resetOT" : "Time out, please submit the Review again",
    "addOT" : "Time out, please submit the Additional Information again",
    "errorPwd" : "Password has to be 6-20 characters, including letters, numbers, \".\", \"_\", \"@\"",
    "verifyAccount" : "Account info is missing, please check again.",
    "selectRegisterTime" : "Please choose your registration time.",
    "enterBindEmail" : "Please insert your verified email.",
    "enterUsedPhoneType" : "Please insert the model of your mobile phone.",
    "enterIdfaGpid" : "Please insert the UDID of your device.",
    "enterContactEmail" : "Incorrect format of Contact E-mail Address; Please re-enter",
    "confirmTermsPrivacy" : "Please read and agree to the service terms and privacy policy.",
    "enterRechargeRemark" : "Please insert your recharge record.",
    "uploadImg" : "Please upload an Image Scan of your ID, maximum size is 20MB",
    "selectIDType" : "Please select the type of your identification document.",
    "enterIDNum" : "Please insert your passport number or ID number.",
    "enterIP" : "Please insert the IP address you used for registration.",
    "enterQueryNum" : "Please enter Review ID",
    "enterQueryPwd" : "Please enter Review Password",
    "errorQueryItem" : "Incorrect Review ID or Password, please try again",
    "enterPassword" : "Please insert a new password.",
    "enterPasswordAgain" : "Please confirm your new password.",
    "enterPasswordNonSame" : "Inconsistent Password",
    "enterEmail" : "Veuillez saisir l\'adresse électronique",
    "sendSuccess" : "L\'e-mail a été envoyé",
    "enterCode" : "Veuillez saisir le code de vérification",
    "errorCode" : "Code de vérification incorrect",
    "selectQuest" : "Veuillez sélectionner une question de sécurité",
    "enterAnswer" : "Veuillez saisir la réponse",
    "selectDifferQuest" : "Veuillez sélectionner 3 questions de sécurité et leurs réponses",
    "addSuccess" : "Your information has been submitted.",
    "picFormt" : "Picture format must be jpg, png or gif",
    "countdownBefore" : "Reset Countdown",
    "countdownAfter" : "(The link will expire at 00:00:00, please submit your application again )",
    "uploadDone" : "Upload done",
    "uploadFail" : "Upload failed",
    "applySuccess" : "Application Approved",
    "applyFailed" : "Application Denied",
    "resetQuestAlterFailed" : "Failed to change security question.",
    "resetQuestError" : "Data input error.",
    "resetQuestNone" : "Inquiry order not found.",
    "resetQuestAltered" : "Security questions have been changed.",
    "illegalOperation" : "Illegal Operation",
    "queryNotExist" : "Inquiry number does not exist.",
    "queryPasswordError" : "Find Password Error",
    "auditing" : "Pending approval",
    "notPass" : "Denied",
    "suppleInformation" : "Submit supplementary information",
    "suppleInformationUnHandle" : "Supplementary information submitted, pending process.",
    "suppleInformationTimeout" : "Submit supplementary information timeout.",
    "repairedAccountSuccess" : "Account repair has been completed.",
    "repairedAccountLost" : "Account repair operation has failed.",
    "loginStateNone" : "Not logged in or session has expired.",
    "repairedAccountTimeout" : "Account repair duration has expired.",
    "changePasswordSucc" : "Password changed.",
    "emailSendFailed" : "Failed to send mail.",
    "emailSendLimit" : "The mailbox may not receive any more verification codes today.",
    "repairedAccountTimeout2" : "Illegal operation account repair duration has expired.",
    "emailCodeSended" : "E-mail verification code has been sent.",
    "alterSuccess" : "Change saved",
    "questionAlterSuccess" : "Security question has been changed.",
    "username" : "Account name",
    "code" : "Please enter the verification code here",
    "selectServiceType" : "Please select Service Type",
    "submitForm" : "Submit the Form",
    "apply" : "Apply",
    "reviewApplicationStatus" : "Review Application Status",
    "instantReviewOfTheStatus" : "Instant Review of the Status",
    "reviewStatus" : "Review Status",
    "backToLogin" : "Back to login",
    "previous" : "Previous",
    "applyDesc" : "Please enter the information so that we can help. You must fill in the blanks with a * . If such information was missing in your account, please enter \"None\".",
    "additionalServices" : "Additional Services",
    "resetSecurityEmail" : "Reset Security E-mail",
    "resetSecurityQuest" : "Reset Security Questions",
    "registrationDate" : "Registration Date",
    "month" : "Month",
    "year" : "Year",
    "emailBound" : "E-mail Bound",
    "modelNumber" : "Mobile model type;",
    "deviceName" : "Device Name",
    "provideRecharge" : "Please provide a detailed and complete Recharge Record, including Time, Method, Amount, Order Number, and Transaction ID for us to confirm.",
    "selectCountry" : "Region",
    "passportID" : "Passport/ ID",
    "upload" : "Upload",
    "del" : "delete",
    "pleaseUpload" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadAgain" : "Upload again",
    "enterDesc" : "Please enter any information that proves the ownership of the account",
    "contactEmail" : "Contact E-mail",
    "applyNoteAttr" : "Note",
    "applyNoteDate" : "please provide your e-mail address so that you can receive the results of your application",
    "agree" : "I have agreed to",
    "UJOYTerms" : "Terms of Use",
    "privacy" : "Privacy Policy",
    "reviewStatusOfAccountFix" : "Review Status of Account Fix",
    "enterReviewID" : "Please enter Review ID",
    "enterReviewPwd" : "Please enter Review Password",
    "review" : "Review",
    "reviewNoteAttr" : "Note",
    "reviewNoteData" : "Check your Contact E-mail in case you forgot the Review ID and Review Password",
    "haveResetInfo" : "You\'ve reset your info",
    "resetProfile" : "Reset your Profile",
    "desc" : "Congrats! Application approved! Please reset your profile.",
    "changePwd" : "Change Password",
    "resetPwd" : "Reset Password",
    "reset" : "Reset",
    "enterNewPwd" : "Please enter new password",
    "confirmNewPwd" : "Please confirm new password",
    "successResetPwd" : "Successfully Reset password",
    "bindSecurityEmail" : "Bind Security E-mail",
    "resetPwdDesc" : "Reset password when you forgot password or account was stolen",
    "bindCommon" : "Bind",
    "sendCommon" : "Send",
    "enterVcode" : "Veuillez saisir le code de vérification",
    "successResetEmail" : "Successfully Reset Security E-mail",
    "resetQuest" : "Reset Security Questions",
    "resetQuestDesc" : "Reset password when you forget your password or you believe your account info was stolen",
    "successResetQuest" : "Successfully Reset Security Questions",
    "hide" : "Hide",
    "addRegisterTime" : "Registration time;",
    "modelNum" : "Model Number: IDFA/GPID",
    "registrationIP" : "Registration IP;",
    "addRechargeRecord" : "Recharge record;",
    "serviceReply" : "Reply from Customer Service:",
    "addDataLimitTime" : "Date for Adding Addititional Information:",
    "addMoreInfo" : "Add More Information",
    "applicationSubmit" : "Application submitted",
    "underReviewStatus" : "Your profile is under review, you will get reply in the next working day. Review status:",
    "reviewID" : "Review ID",
    "reviePwd" : "Review Password",
    "enterReviewIDNPwd" : "Enter Review ID and Review Password to check status",
    "homepage" : "Homepage",
    "checkEmailAttr" : "Note",
    "checkEmailData" : "Check your Contact E-mail in case you forgot your Review ID and Review Password",
    "underReview" : "Under Review",
    "underReviewReply" : "Your profile is under review.We will reply as soon as possible. Thank you for your patience!",
    "failed" : "Application Failed",
    "reason" : "Reason: ### Therefore, application failed, please provide correct information, our staff will help. Thank you for your cooperation!",
    "underReviewAdd" : "Your profile is under review. Part of the information is missing or inconsistent, please add more information for us to confirm!",
    "addInfoRequired" : "Additional Information Required",
    "dateForAddInfo" : "Date for Adding Addititional Information:",
    "addInfo" : "Additional Information",
    "addInfoSubmit" : "Additional Information has been submitted! Thank you for your patience!",
    "hasBeenRepaired" : "Account has been repaired",
    "opExpired" : "Account repair operation expired",
    "approved" : "Approved",
    "haveSubmitted" : "You\'ve submitted",
    "sessionExpired" : "You\'ve not yet logged in or session value has expired",
    "submitted" : "Submitted",
    "addItemRegisterDate" : "E-mail;",
    "addItemDeviceNumber" : "UDID;",
    "reasonItemPwd" : "Inconsistent ID Number;",
    "addItemIDPhoto" : "ID Photo;",
    "idfaTitle" : "How to find your device IDFA or GPID?",
    "idfaSubTitle1" : "For ios user—finding your IDFA",
    "idfaSubTitle1Desc1" : "1.Download the app 【<em>MyIDFA</em>】from App Store",
    "idfaSubTitle1Desc2" : "2.Open this <em>app</em> and you will find your device <em>IDFA</em>.",
    "idfaSubTitle2" : "For Android user—finding your GPID",
    "idfaSubTitle2Desc1" : "1.tab the <em>“settings”</em> button",
    "idfaSubTitle2Desc2" : "2.tab the <em>“Google”</em> icon below the <em>ACCOUNTS</em> page",
    "idfaSubTitle2Desc3" : "3.then tab the <em>“Ads”</em> icon, and you will find your <em>GPID</em>",
    "uploadIDCard" : "Please upload an Image Scan of your ID, with maximum size of 20MB",
    "uploadTipsBefore" : "File size must not be greater than",
    "uploadTipsAfter" : "M",
    "submitError" : "Error caused by missing ID number or wrong account info.",
    "applyLimitError" : "Daily application limit exceeded. (3 times each day)",
    "applyDisabled" : "You may only submit once every 10 minutes.",
    "inputDataError" : "Data is not completed.",
    "dataException" : "Data exception",
    "picSizeLimit" : "Picture file size must not exceed 5MB",
    "picTypeLimit" : "Upload JPG, PNG, GIF files only",
    "picNull" : "Picture is empty",
    "alteredPassword" : "Password has been changed.",
    "inputError" : "Input error.",
    "pwdChangefailed" : "Failed to change password.",
    "sendEmailCodeDisabled" : "Verification code can only be sent again after a period of time.",
    "alteredEmail" : "E-mail has been changed.",
    "inputEmailError" : "E-mail input error",
    "operationFailed" : "Operation failed",
    "codeNull" : "You have not entered a verification code yet.",
    "findPwd" : "Mot de passe oublié",
    "findAccountAndPwd" : "Forgot account/password",
    "usualDeviceNum" : "Model Number: IDFA/GPID",
    "usualPhoneNum" : "Device Name",
    "registerTimeError" : "Inconsistent Registration Date;",
    "bindEMailError" : "Inconsistent Bound E-mail;",
    "rechargeRecordError" : "Inconsistent Recharge Record;",
    "registerIPError" : "Inconsistent Registration IP address;",
    "deviceNumError" : "Inconsistent IDFA/GPID;",
    "deviceModelError" : "Inconsistent Device Model;",
    "confirmTerms" : "Please agree to terms of service",
    "applyFixAccount" : "Si les méthodes ci-dessus ne marchent pas, vous pouvez soumettre une demande de <span>récupération de compte</span>.",
    "findPwdByFixAccount" : "You are advised to set a security e-mail for account recovery.",
    "connectFail" : "Disconnected from Google Services, please try again",
    "h5_favour_has_gift" : "Bookmark to browser! (This account has claimed the reward already)",
    "h5_favour_get_gift" : "Congrats! You obtained the reward. Please check in-game.",
    "h5_get_gift_fault" : "Unable to claim. Please try again later, and contact our CS if the problem remains.",
    "h5_favour_please_select" : "Please choose server/character",
    "h5_favour_login_get" : "Log in and bookmark to the browser to claim a reward!",
    "h5_favour_tip" : "Bookmark to the browser to claim a reward!",
    "h5_favour_select_serve" : "Please choose server",
    "h5_favour_select_role" : "Please choose character",
    "store_product_paytype_error" : "You may not purchase the selected item through this payment method.",
    "SwitchWithThirdWay" : "Changer à \${type}",
    "moreGame" : "more games",
    "serviceTitle" : "Service",
    "h5_download_login" : "Please log in first.",
    "h5_download_tips" : "Please start the game from the client.",
    "h5_download_repeat_get" : "You have claimed this giftpack.",
    "h5_download_succ" : "Please download the client first.",
    "h5_download_repeat_role" : "Character is bound",
    "currentLoginAccount" : "Current account:",
    "fb_canvas_fullscreen" : "Expand",
    "fb_canvas_website" : "Homepage",
    "fb_canvas_like_share" : "Share",
    "fb_canvas_service" : "Support",
    "fb_canvas_login_fail" : "Login failed",
    "fb_canvas_pay_return" : "You have cancelled the transaction",
    "fb_canvas_root_tip" : "Please log in Facebook to authorize first",
    "h5_popup_title" : "Payment way",
    "h5_popup_submit" : "Pay",
    "h5_popup_last_used" : "Last used",
    "h5_popup_quit_tips" : "Are you sure to cancel payment",
    "h5_popup_quit_check" : "YES",
    "h5_popup_quit_cancel" : "NO",
    "h5_popup_currency_sign" : "\$",
    "h5_popup_product_empty" : "Product information has not been obtained yet. Please refresh page",
    "h5_popup_server_empty" : "There is no server list yet. Please refresh page",
    "aboutRelevanceAccount" : "Already have an account?",
    "selectLoginType" : "Select a login method",
    "touristDescription" : "If you already have an account, you can log in as a guest and then use the OTP (One-Time Password) feature in the user center to switch accounts. This feature requires the OTP functionality to be set up on your mobile device in the user center.",
    "touristSuggest" : "If you already have an account, you can log in as a guest and then tap the \"Switch Account\" option in the user center. From there, you can log in using a previously bound social media account.",
    "h5_tourist_remenber" : "Remember me for 14 days",
    "account_czsm1" : "1、全てのゲームデータが新しい端末に引き継がれます。OSの異なる端末で引き継ぐことも可能です；",
    "account_czsm2" : "2、引き継ぐ時のパスワードを登録してください。",
    "account_czsm3" : "3、セキュリティ保護のため、",
    "account_wzfdmm" : "大文字と小文字を区別して、6-16文字のパスワードをご入力",
    "account_qzcsrmm" : "再度パスワードをご入力",
    "account_fxyjm" : "引き継ぎコード発行",
    "account_yjmsm1" : "1、タイトル画面にある「ユーザーセンター」をタップ、「切り替え」のページで引き継ぎを行ってください。",
    "account_yjmsm2" : "2、引き継ぎナンバーに使用期限はございません。",
    "account_yjmsm3" : "3、引き継ぎコードは一度しか使えません。再度引き継ぐことができます。",
    "account_yjmsm4" : "4、アカウントを保護するため、引き継ぎコードを他人に教えないようにしてください。",
    "account_fz" : "コピー",
    "account_cxfx" : "新規で発行する",
    "account_czsm4" : "アカウントを連携",
    "account_czsm5" : "してください。",
    "account_yjm" : "引き継ぎコード",
    "account_16wzzj" : "パスワードの長さは6～16文字にする",
    "account_qsrzqdyjmhmm" : "正しい引き継ぎコードとパスワードを入力してください。",
    "account_yj" : "引き継ぎ",
    "accoun_lcsrdmmbyz" : "パスワードの両回の入力は一致しない",
    "deleteaccount_step3_1" : "within the 14 days. Revoke now?",
    "account_syyjm" : "1. 引き継ぎコードを使ってゲームデータがこの端末に引き継がれます。",
    "account_yjmznsyyc" : "2. 引き継ぎコードは一度しか使えず、再発行することができます。",
    "account_sryjm" : "引き継ぎコードを入力",
    "account_srmm" : "パスワードを入力",
    "h5_header_gift" : "",
    "h5_award_popup_type" : "",
    "h5_award_popup_content" : "",
    "h5_award_popup_code" : "",
    "h5_favour_gift_name" : "",
    "h5_download_gift_name" : "",
    "h5_award_popup_exchange_way" : "",
    "h5_succ_get_gift" : "",
    "h5_exchange_info_title" : "",
    "h5_exchange_info_1" : "",
    "h5_exchange_info_2" : "",
    "h5_check_gift" : "",
    "account_delete_scdqzh" : "Êtes-vous sûr de vouloir supprimer le compte ainsi que ses données ?",
    "account_delete_fwq" : "Serveur",
    "account_delete_zhm" : "Personnage",
    "account_delete_jshflj" : "Lien récupération personnage",
    "account_delete_qzyzmdxx" : "(Sensible aux majuscules et minuscules)",
    "account_delete_jtbcysxx" : "Il est conseillé de prendre une capture d\\&#039;écran des informations ci-dessus pour la récupération du compte.",
    "deleteaccount_step3_2" : "After 14 days, your account will be deleted. You will not be able to restore your account. You will lose all your account information.\n\nYou may revoke the account deletion through",
    "h5_guest_login" : "Guest",
    "h5_click_copy" : "",
    "questionnaire_btn" : "Questionnaire",
    "h5_header_store_text" : "Recharge",
    "h5_header_home_text" : "Homepage",
    "h5_check_gift_list_text" : "Infos de récompense",
    "yourServer" : "Votre Serveur",
    "allServer" : "Tous les Serveurs",
    "h5_header_screen" : "Plein écran",
    "h5_verticalTip" : "Mode paysage recommandé.",
    "h5_third_party_login_tips" : "If you want to log in using a social media account (such as Facebook, Google, Twitter, etc.), you can first log in as a guest and then bind your social media account in the user center.",
    "webStoreUidTitle" : "",
    "webStoreUidTips" : "",
    "webStoreUidGuide" : "",
    "webStoreUidInputt" : "",
    "feedbackTips" : "",
    "recentPlay" : "Récent",
    "moreGames" : "Plus",
    "previousSelect" : "Previous",
    "payAgainBtn" : "Top-up again",
    "packageTypeName" : "Pack",
    "coinTypeName" : "Top-up",
    "cardTypeName" : "Monthly Card",
    "orderNormal" : "par défaut",
    "orderPriceUp" : "Price↑",
    "orderPriceDown" : "Price↓",
    "returnSelectRole" : "Return",
    "jiamaInfo" : "Bonus du mode de paiement\nMonnaie bonus = Montant payé * taux de la devise * taux de bonus x Bonus du mode de paiement\nMonnaie bonus = Montant payé * taux de la devise * taux de bonus\n*Note : la monnaie bonus ne sera pas comptabilisée par les événements de recharge ou l\'EXP VIP.*Pour les jeux lancés dans le monde entier, le montant du paiement est calculé en dollars américains. Veuillez contacter le service clientèle si vous avez des questions.",
    "lastSelectTag" : "Used previously",
    "onestore_subscribe_manage" : "Manage",
    "onestore_subscribe_entrance" : "OneStore Subscription",
    "onestore_subscribe_has_expire" : "Expired",
    "onestore_subscribe_expire_time" : "Expire on \${month}/\${day}/\${year}",
    "onestore_subscribe_privacy" : "About Subscription and Privacy",
    "onestore_subscribe_cancel_subscribe" : "Cancel Subscription",
    "onestore_subscribe_info_title" : "Subscription Info",
    "onestore_subscribe_option_title" : "Options",
    "onestore_subscribe_do_not_subscribe" : "No subscribed items.",
    "onestore_subscribe_get_role_fail" : "Failed to subscribe. Please open this page again in the game.",
    "onestore_subscribe_later" : "Later",
    "onestore_subscribe_confirm" : "Confirm",
    "onestore_subscribe_confirm_cancel" : "Confirm Cancellation",
    "onestore_subscribe_popup_tip" : "If you cancel now, you can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_detail_tip" : "Subscribed item will be renewed on \${month}/\${day}/\${year} (Price: \${prices}/month). Subscription can be canceled 1 day before it expires.",
    "onestore_subscribe_expired_tip" : "Please subscribe the expired item from the in-game Mall/Shop",
    "onestore_subscribe_goon_sub" : "Renew on \${month}/\${day}/\${year}",
    "onestore_subscribe_has_cancel_tip1" : "Subscription canceled. You can still access your subscription until \${month}/\${day}/\${year}.",
    "onestore_subscribe_has_cancel_tip2" : "If you wish to subscribe again. Please do so in the in-game Mall/Shop.",
    "onestore_subscribe_cancel_fail" : "Failed to cancel subscription. Please try again later.",
    "onestore_subscribe_cancel_fail_title" : "Cancel Subscription",
    "apple_deleteaccount" : "Delete Account",
    "apple_deleteaccount_title" : "Request account deletion",
    "apple_deleteaccount_step1_1" : "Please read the following terms and conditions carefully:",
    "apple_deleteaccount_step1_2" : "Your account will be frozen for 14 days since the account deletion.",
    "apple_deleteaccount_step1_3" : "Your account will be <span class=\"highlight\">permanently deleted</span> if you do not revoke the deletion process in 14 days. Upon deletion of your account, you will not be able to use it to log into the game. All information on your account will be deleted.",
    "apple_deleteaccount_step1_4" : "If you wish to unlink social media account from the account, please contact the customer service team for unlinking operation before deleting your account. Otherwise, upon successful deletion of your account, you will not be able to use your linked social media account to log into the game.",
    "apple_deleteaccount_step1_5" : "Please make sure you have properly disposed your virtual assets in the game before applying for the deletion of your account.<span class=\"highlight\">If you wish to apply for refund, please also do it before deleting your account</span>.",
    "apple_deleteaccount_step1_6" : "You may revoke the deletion within the 14 days through the link below, please save the link in advance:",
    "apple_deleteaccount_step2_1" : "Have you properly disposed your virtual assets in the game? If you haven\'t, please contact the customer service team for the matter before submitting an account deletion request.",
    "apple_deleteaccount_step2_2" : "Please save your server and character information which will be required for restoring your account.",
    "apple_deleteaccount_step2_3" : "Please type \"Delete\" to complete the deletion",
    "apple_deleteaccount_step3_1" : "Your account deletion request has been submitted. The following account is now frozen:",
    "apple_deleteaccount_step3_2" : "We will permanently delete your account after 14 days if there is no further request for revoking the deletion from you.",
    "apple_deleteaccount_step3_3" : "You can visit the following link to revoke the deletion within the 14 days period",
    "apple_deleteaccount_step4_1" : "You have deleted your old account. Please log in with a new account next time.",
    "apple_deleteaccount_agree" : "I have read and agree to the terms and conditions above",
    "apple_deleteaccount_server" : "Server",
    "apple_deleteaccount_roleName" : "Character",
    "copyLink" : "Copy Link",
    "copyTextAndImg" : "please copy and save the link or take a screenshot",
    "copyLinkAndRoleInfo" : "Copy Link & Character",
    "hasCopy" : "Copied to clipboard",
    "quickcard_tips" : "The information of your credit card has been encrypted and secured by Worldpay. The displayed information is only to provide a better experience.",
    "quickcard_use_new_card" : "New credit card",
    "edit" : "Edit",
    "save" : "Save",
    "quickcard_confirm_delete" : "Delete?",
    "quickcard_popup_tip" : "If you want to use this card again after deleting it, please choose the \"New credit card\" option.",
    "quickcard_result_tip_one" : "Si vous avez choisi d\'enregistrer votre numéro de carte sur la page précédente, nous collecterons les données de votre carte (**** **** **** 1234) en version cryptée.",
    "quickcard_result_tip_two" : "Nous stockons les données cryptées uniquement pour votre confort, et vous n\'avez pas à saisir les numéros de carte lors de votre prochain achat.",
    "quickcard_learn_more" : "Learn more 》",
    "quickcard_info_title" : "Déclarations d\'informations d\'identification stockées",
    "quickcard_info_tip_one" : "Pour mieux protéger la sécurité des données des clients, Visa et Mastercard introduisent de nouvelles définitions pour ces « informations d\'identification stockées », ainsi que de nouvelles règles pour les informations d\'identification stockées et les transactions initiées par le commerçant.",
    "quickcard_info_tip_two" : "Lorsque vous effectuez un achat sur notre site Web, nous recueillons les données de votre carte (1234 **** **** 1234) en version cryptée. Nous conserverons les détails cryptés pendant 4 ans et mettrons à jour l\'accord, la politique de confidentialité sur notre site Web en cas de changement. Nous conservons les détails cryptés uniquement par souci de commodité, et vous ne devez pas saisir les numéros de carte lors de votre prochain achat.",
    "search_product" : "trouver l\'objet",
    "search_price" : "trouver le prix",
    "price" : "prix",
    "product_no_found" : "Aucun article/prix n\'est trouvé",
    "price_no_found" : "Aucun article/prix n\'est trouvé",
    "search_no_found" : "Aucun article/prix n\'est trouvé",
    "product" : "article",
    "store_tag_hot" : "HOT",
    "store_tag_discount" : "Discount",
    "store_tag_double" : "Double",
    "store_tag_treble" : "Treble",
    "store_tag_sale" : "SALE",
    "store_tag_top_seller" : "TOP SELLER",
    "store_tag_off_10" : "10%OFF",
    "store_tag_off_20" : "20%OFF",
    "store_tag_off_30" : "30%OFF",
    "store_tag_off_40" : "40%OFF",
    "store_tag_off_50" : "50%OFF",
    "store_tag_off_60" : "60%OFF",
    "store_tag_off_70" : "70%OFF",
    "store_tag_off_80" : "80%OFF",
    "store_tag_off_90" : "90%OFF",
    "store_tag_event" : "Event",
    "store_tag_daily" : "Daily",
    "store_tag_weekly" : "Weekly",
    "store_tag_monthly" : "Monthly",
    "subscriptionTypeName" : "subscription",
    "useDoubleSend" : "Use Box Multiplier?",
    "doubleSendInfo" : "Since you used a Box Multiplier, some of the items you purchased were doubled (as shown at the bottom)!",
    "storeRoleTitle" : "Veuillez choisir un caractère",
    "storeSocialLogin" : "Se connecter avec des comptes SNS",
    "storeAccountIdLogin" : "Se connecter avec l\'ID du compte",
    "storeInputId" : "Enter account ID",
    "storeSearch" : "Rechercher",
    "storeSelectProductTitle" : "Choisir les Objets",
    "storeInputNameSearch" : "Entrez le nom de l\'objet et recherchez-le",
    "storeInputPriceSearch" : "Entrez le prix de l\'objet et recherchez",
    "storeNoFindProduct" : "Article non trouvé. Veuillez réessayer.",
    "storePriceUp" : "Prix↑",
    "storePriceDown" : "Prix↓",
    "storeLookDetail" : "Détails",
    "storeChangeProduct" : "Modifier l\'objet",
    "storeWelcome" : "Bienvenue",
    "storeLookMore" : "Plus de",
    "storeHasSelect" : "Objet sélectionné",
    "storeTotal" : "Total",
    "storeExtra" : "Bonus",
    "storeProductDetail" : "Détails",
    "storeUidGuideStep1" : "Appuyez sur Paramètres > Plus > Compte",
    "storeUidGuideStep2" : "Saisissez l\'ID du compte lors du rechargement",
    "storeSelectAndLook" : "Veuillez d\'abord sélectionner votre personnage",
    "storeSwitchWay" : "Changer de méthode de connexion",
    "type1" : "Remises quotidiennes",
    "type2" : "héros",
    "type3" : "Équipement bataille",
    "type4" : "",
    "type5" : "Puce",
    "type6" : "Nova",
    "type7" : "Ressources",
    "type8" : "Accélération bâtiment",
    "type9" : "Objets rares",
    "type10" : "Alliance",
    "type11" : "Diamant",
    "type12" : "Module",
    "type13" : "Cube",
    "type14" : "",
    "type15" : "Nano-armes",
    "type16" : "Prix final",
    "type17" : "",
    "type9999" : "Offre limitée",
    "type10000" : "Centre cadeau",
    "type10001" : "Événements des vacances",
    "typeother" : "Autres articles",
    "switchChar" : "Changer de personnage",
    "howToFindUid" : "Comment trouver l\'ID de mon compte ?",
    "choosePayWay" : "Choisir un mode de paiement",
    "new_apple_deleteaccount_stepsub_title" : "Annuler l\'auto-renouvellement",
    "new_apple_deleteaccount_stepsub_1" : "Un abonnement à renouvellement automatique se trouve sous votre compte. Il vous est conseillé d\'annuler l\'auto-renouvellement avant de supprimer votre compte pour éviter tout achat involontaire.",
    "new_apple_deleteaccount_stepsub_2" : "Annuler l\'auto-renouvellement",
    "new_apple_deleteaccount_stepsub_later" : "Plus tard",
    "new_apple_deleteaccount_stepsub_now" : "Maintenant",
    "new_apple_deleteaccount_title" : "Demande de suppression du compte",
    "new_apple_deleteaccount_step1_1" : "Veuillez lire attentivement les conditions générales suivantes :",
    "new_apple_deleteaccount_step1_2" : "Votre compte sera <span class=\"highlight\">supprimmé de manière permanente</span> dès sa suppression. Vous ne pourrez PAS l\'utiliser pour vous connecter au jeu. Toutes les informations supprimées de votre compte ne pourront PAS être récupérées.",
    "new_apple_deleteaccount_step1_3" : "Si vous souhaitez de délier votre compte de médias sociaux de votre compte, veuillez contacter l\'équipe du service clientèle pour l\'opération de déliaison avant de supprimer votre compte. Sinon, après la suppression réussie de votre compte, vous ne pourrez pas utiliser votre compte de médias sociaux lié pour vous connecter au jeu. Veuillez vous assurer que vous avez correctement disposé de vos actifs virtuels dans le jeu avant de demander la suppression de votre compte.",
    "new_apple_deleteaccount_step1_4" : "<span class=\"highlight\">Si vous souhaitez demander un remboursement, veuillez également le faire avant de demander la suppression de votre compte.</span> Veuillez vous assurer que vous avez correctement disposé de vos actifs virtuels avant de demander la suppression de votre compte.",
    "new_apple_deleteaccount_step2_1" : "Avez-vous correctement disposé de vos actifs virtuels dans le jeu ? Si ce n\'est pas le cas, veuillez contacter l\'équipe du service clientèle à ce sujet avant de soumettre une demande de suppression de compte.",
    "new_apple_deleteaccount_step2_2" : "Veuillez saisir \"Delete\" pour terminer la suppression. La suppression du compte ne peut être révoquée une fois exécutée.",
    "new_apple_deleteaccount_step2_3" : "Veuillez saisir \"Delete\" pour terminer la suppression",
    "new_apple_deleteaccount_step3_1" : "Votre demande de suppression de compte a été soumise. Le compte suivant a été supprimé :",
    "new_apple_deleteaccount_step3_2" : "Veuillez créer un nouveau compte si vous souhaitez vous connecter à nouveau au jeu.",
    "new_apple_deleteaccount_step4_1" : "Vous avez supprimé votre ancien compte. Veuillez vous connecter avec un nouveau compte la prochaine fois.",
    "currencyTypeName" : "Devise",
    "has_select_product" : "Vos Objets :",
    "n_product" : "\${n}",
    "look_detail_product" : "Tout Voir",
    "limit_buy_product" : "Limite d\'achat pour cet objet : \${n}",
    "limit_order" : "Vous ne pouvez acheter qu\'un maximum de \${n} objets à la fois.",
    "limit_order_remove_tip" : "Vous avez atteint la limite d\'achat pour certains objets de ce panier. Voulez-vous les supprimer ?",
    "paytype_limit" : "Ce mode de paiement ne peut pas être utilisé pour acheter certains de vos objets. Veuillez choisir un autre mode de paiement ou essayer de les acheter séparément.",
    "check_remove_cart" : "Retirer du panier ?",
    "remove_cart" : "Retirer",
    "confirm_product" : "Confirmer",
    "select_paytype" : "Sélectionnez le Mode de paiement",
    "cart_is_empty_tip" : "Aucun objet trouvé. Veuillez d\'abord sélectionner un objet.",
    "thirty_tip" : "Si les objets que vous avez achetés n\'arrivent pas dans les 30 minutes, veuillez contacter notre service clientèle.",
    "total_n_product" : "Objet x\${n}",
    "look_detail_of_cart" : "Afficher Tout",
    "order_detail" : "Liste d\'objets",
    "total_detail" : "Quantité :",
    "add_to_cart" : "Ajouter au Panier",
    "back_to_select" : "Retour",
    "fail_and_later" : "Item info error. Please try again later.",
    "nextStep" : "Confirm",
    "pnsGameName" : "Puzzles & Survival",
    "enterOfficial" : "Accéder au\nSite internet",
    "visitorLogin" : "Invité",
    "tokenLogin" : "OTP",
    "fbLogin" : "Se connecter avec Facebook",
    "googleLogin" : "Se connecter avec Google",
    "twitterLogin" : "Se connecter avec Twitter",
    "vkLogin" : "Se connecter avec VK",
    "agreementTextStart" : "En vous connectant au jeu, vous confirmez que vous avez lu et accepté les Conditions de service et Politique de confidentialité.",
    "userCenter" : "Centre utilisateur",
    "welcomeBack" : "Bienvenue",
    "continueGame" : "DÉMARRER",
    "officialPay" : "Centre de recharge",
    "changeAccount" : "Changer de compte",
    "back" : "Retour",
    "tokenKey" : "OTP",
    "inputUid" : "Entrez votre UID",
    "inputToken" : "Entrez votre OTP",
    "inputCkCode" : "Saisir le texte",
    "enterGame" : "DÉMARRER",
    "tokenTip" : "Protégez votre compte avec la vérification OTP",
    "howToGetToken" : "Comment obtenir mon mot de passe à usage unique ?",
    "getStep1" : "Étape 1 : Allez dans Paramètres > Compte > Centre d\'utilisateur",
    "getStep2" : "Étape 2 : Appuyez sur OTP",
    "getStep3" : "Étape 3 : Copiez et entrez votre UID et votre mot de passe à usage unique",
    "copy" : "Copier",
    "lastRefresh" : "Actualisation dans :",
    "second" : "s",
    "immediatelyRefresh" : "Actualiser maintenant",
    "frequently" : "Opération trop fréquente. Veuillez réessayer plus tard.",
    "loginFail" : "La connexion a échoué. Mot de passe incorrect.",
    "tokenIntro" : "À propos du mot de passe à usage unique (OTP)",
    "tokenIntro1" : "1. Les mots de passe à usage unique expirent dans 120 secondes. Utilisez-les à bon escient pour préserver la sécurité de votre compte.",
    "tokenIntro2" : "2. Le personnel de ne vous demandera pas votre mot de passe à usage unique. Veuillez ne jamais partager ou donner votre mot de passe.",
    "nextStep1" : "Confirm",
    "couponCanUse" : "Utilisables",
    "couponCanNotUse" : "Inutilisables",
    "couponHasNoCoupon" : "Pas de coupons",
    "couponUseTip" : "Utilisez 1 coupon pour chaque commande",
    "couponValidTime" : "Validité",
    "couponFuilCanUse" : "Utilisable pour les commandes supérieures à  \${price} \${currency}",
    "couponNoLimit" : "Aucune limitation",
    "couponAllProductCanUse" : "Tous les objets",
    "couponPartProductCanUse" : "Objets spécifiques",
    "couponPartPaytypeCanUse" : "Canaux de paiement spécifiques",
    "couponOnlyCoinCanUse" : "Pour la monnaie du jeu uniquement",
    "couponOnlyDiamondCanUse" : "Pour les diamants uniquement",
    "couponOnlyPackageCanUse" : "Pour les packs uniquement",
    "couponOnlySubCanUse" : "Pour les abonnements uniquement",
    "couponOnlyDaibiCanUse" : "Pour les jetons uniquement",
    "couponMaxDiscount" : "Remise jusqu\'à \${price} \${currency}",
    "couponHasUsed" : "Utilisé",
    "couponReductionType" : "Déduction",
    "couponDiscountType" : "Remise",
    "couponUseNow" : "Utilisez",
    "couponHasNoSelect" : "Ne pas utiliser de coupon",
    "couponHasSelectQuan" : "Prix réduit",
    "couponSubmitTip" : "Les coupons seront utilisés",
    "couponCanUseQuan" : "Coupons",
    "couponOrderTotal" : "Total",
    "couponHasDiscount" : "Remise",
    "couponPayTotal" : "Paiement",
    "couponCancel" : "Annuler",
    "couponConfirm" : "Confirmer",
    "uidLoginName" : "Se connecter avec OTP",
    "uidToken" : "OTP",
    "uidInputUid" : "Entrez votre UID",
    "uidInputToken" : "Entrez votre OTP",
    "uidInputCode" : "Saisir le texte",
    "uidTipTitle" : "Protégez votre compte avec la vérification OTP",
    "uidTipHowToGet" : "Comment obtenir mon mot de passe à usage unique ?",
    "uidTipStep1" : "Étape 1 : Allez dans Paramètres > Compte > Centre d\'utilisateur",
    "uidTipStep2" : "Étape 2 : Appuyez sur OTP",
    "uidTipstep3" : "Étape 3 : Copiez et entrez votre UID et votre mot de passe à usage unique",
    "uidTipIntro1" : "1. Les mots de passe à usage unique expirent dans 60 secondes. Utilisez-les à bon escient pour préserver la sécurité de votre compte.",
    "uidTipIntro2" : "2. Le personnel de ne vous demandera pas votre mot de passe à usage unique. Veuillez ne jamais partager ou donner votre mot de passe.",
    "couponMyQuan" : "Coupons",
    "couponSelectPaytypeTip" : "Sélectionnez le canal de paiement pour voir les infos de la remise",
    "couponSelectCouponTip" : "Sélectionnez les coupons pour voir le prix réduit",
    "couponValidQuanTip" : "(Coupon x\${num} utilisable)",
    "couponLookCart" : "Panier",
    "couponUnfoldCart" : "Cacher",
    "couponCoupon" : "Coupon",
    "couponNoUse" : "Non utilisé",
    "couponSelect" : "Sélectionner un Coupon",
    "couponSureUse" : "Utilisez",
    "couponReturn" : "Retour",
    "couponInvalidTime" : "Expire le",
    "couponBuyNow" : "Acheter Maintenant",
    "couponAllType" : "all",
    "ztmslgType1" : "Remises quotidiennes",
    "ztmslgType2" : "héros",
    "ztmslgType3" : "Équipement bataille",
    "ztmslgType4" : "",
    "ztmslgType5" : "Puce",
    "ztmslgType6" : "Nova",
    "ztmslgType7" : "Ressources",
    "ztmslgType8" : "Accélération bâtiment",
    "ztmslgType9" : "Objets rares",
    "ztmslgType10" : "Alliance",
    "ztmslgType11" : "Diamant",
    "ztmslgType12" : "Module",
    "ztmslgType13" : "Cube",
    "ztmslgType14" : "",
    "ztmslgType15" : "Nano-armes",
    "ztmslgType16" : "Prix final",
    "ztmslgType17" : "Noyau",
    "ztmslgType9999" : "Offre limitée",
    "ztmslgType10000" : "Centre cadeau",
    "ztmslgType10001" : "Événements des vacances",
    "ztmslgTypeother" : "Other",
    "antslgType1" : "Promotion Quotidienne",
    "antslgType2" : "Fourmi spécialisée",
    "antslgType3" : "Équipement",
    "antslgType5" : "Gène",
    "antslgType6" : "Escargot",
    "antslgType7" : "Ressources",
    "antslgType8" : "Construire & Rechercher",
    "antslgType9" : "Objets Rares",
    "antslgType10" : "Alliance",
    "antslgType11" : "Diamant",
    "antslgType12" : "Cellule",
    "antslgType13" : "Totem",
    "antslgType9999" : "Offre limitée",
    "antslgTypeother" : "other",
    "typeall" : "Tous les articles",
    "vipHead" : "Points VIP",
    "vipHead213": "Adhésion Premium",
    "vipTitle" : "Événement Points VIP",
    "nowLevel" : "Votre niveau :",
    "myVipScore" : "Vos pts :",
    "nextLevelNeed" : "(Gagnez \${num} points supplémentaires pour obtenir \${level} VIP)",
    "ruleTitle" : "Règles :",
    "ztmslgVipRule1" : "1. L\'événement commence à 00:00 (UTC) le 2022/09/22",
    "ztmslgVipRule2" : "2. Jeux disponibles :  Puzzles & Survival",
    "ztmslgVipRule3" : "Chaque type de récompense de l\'événement ne peut être réclamé qu\'une seule fois.",
    "ztmslgVipRule4" : "3. Événement Coupon de Connexion : en accédant à la page de recharge pour la première fois, vous pourrez réclamer un coupon de -15 %.",
    "ztmslgVipRule5" : "4. Événement Points VIP : achetez un objet sur notre page officielle pour gagner des points et obtenir des coupons de niveau et des coupons hebdomadaires.",
    "ztmslgVipRule6" : "5. Les points que vous pouvez gagner peuvent varier en fonction de la devise que vous utilisez. Pour plus de détails, veuillez consulter le lien en bas de page.",
    "ztmslgVipRule7" : "6. Lorsque vous utilisez des coupons, vous gagnez des points sur la base du montant que vous avez payé après déduction des coupons.",
    "ztmslgVipRule8" : "7. Les points que vous avez gagnés expireront dans 365 jours. Cela peut affecter votre niveau VIP.",
    "ztmslgVipRule9" : "8. Vous recevrez immédiatement un coupon pour avoir atteint un niveau VIP pour la première fois. Le coupon hebdomadaire pourra être réclamé à 00:00 (UTC+0) chaque samedi.",
    "ztmslgVipRule10" : "9. Vous devrez vous connecter pour réclamer le coupon hebdomadaire. Ne manquez pas cette occasion !",
    "ztmslgVipRule11" : "10. La devise du coupon sera la devise de la dernière commande que vous avez effectuée. Veuillez contacter notre service clientèle si vous souhaitez changer la devise utilisée.",
    "ztmslgVipRule12" : "11. Voir le tableau ci-dessous pour plus de détails sur les niveaux VIP et les coupons.",
    "ztmslgVipRule13" : "12. En cas de litige, l\'équipe d\'assistance de Puzzles & Survival a la seule et dernière discrétion d\'interprétation des présentes conditions générales.",
    "vipLevel" : "Niveau VIP",
    "vipCondition" : "Pts requis",
    "firstSend" : "Cadeau der premier accomplissement",
    "weeklySend" : "Coupon hebdomadaire",
    "lastAllCoupon" : "Coupons du palier précédent",
    "besides" : "Tableau des Devises/Points :",
    "couponRatio" : "Taux des Devises/Points",
    "backToPay" : "RETOUR",
    "quanGift" : "COUPON",
    "quanGiftTips" : "Vous avez un ou plusieurs coupons réclamables !",
   "antslgVipRule1": "En raison d'une mise à jour des fonctionnalités, l'événement \"Points VIP\" sera bientôt supprimé.",
    "antslgVipRule2": "Veillez à utiliser les coupons obtenus lors de l'événement \"Points VIP\" avant qu'ils n'expirent.",
    "antslgVipRule3": "Heure de Fin : 28/09/2024 00:00:00 (UTC)",
    "antslgVipRule4": "Après l'événement, vous pouvez visiter le Centre de Membres Premium pour bénéficier de plus d'avantages :",
    "antslgVipRule5": "Terminez des quêtes pour gagner des points, qui peuvent être échangés contre des coupons, des objets en jeu et d'autres récompenses ! Profitez d'avantages exclusifs et de tirages chanceux.",
    "antslgVipRule6": "Restez à l'écoute pour plus de récompenses et d'événements !",
    "dzgVipRule0" : "1. L\'événement commence à 00:00 (UTC) le 2022/09/27",
    "dzgVipRule1" : "1. Jeux disponibles : \${gameName}",
    "dzgVipRule2" : "Chaque type de récompense de l\'événement ne peut être réclamé qu\'une seule fois.",
    "dzgVipRule3" : "2. Événement Coupon de Connexion : en accédant à la page de recharge pour la première fois, vous pourrez réclamer un coupon de -15 %.",
    "dzgVipRule4" : "3. Événement Points VIP : achetez un objet sur notre page officielle pour gagner des points et obtenir des coupons de niveau et des coupons hebdomadaires.",
    "dzgVipRule5" : "4. Les points que vous pouvez gagner peuvent varier en fonction de la devise que vous utilisez. Pour plus de détails, veuillez consulter le lien en bas de page.",
    "dzgVipRule6" : "5. Lorsque vous utilisez des coupons, vous gagnez des points sur la base du montant que vous avez payé après déduction des coupons.",
    "dzgVipRule7" : "6. Les points que vous avez gagnés expireront dans 365 jours. Cela peut affecter votre niveau VIP.",
    "dzgVipRule8" : "7. Vous recevrez immédiatement un coupon pour avoir atteint un niveau VIP pour la première fois. Le coupon hebdomadaire pourra être réclamé à 00:00 (UTC+0) chaque samedi.",
    "dzgVipRule9" : "8. Vous devrez vous connecter pour réclamer le coupon hebdomadaire. Ne manquez pas cette occasion !",
    "dzgVipRule10" : "9. La devise du coupon sera la devise de la dernière commande que vous avez effectuée. Veuillez contacter notre service clientèle si vous souhaitez changer la devise utilisée.",
    "dzgVipRule11" : "10. Voir le tableau ci-dessous pour plus de détails sur les niveaux VIP et les coupons.",
    "dzgVipRule12" : "11. En cas de litige, l\'équipe d\'assistance de \${gameName} a la seule et dernière discrétion d\'interprétation des présentes conditions générales.",
    "213dzgVipRule1" : "En raison d'une mise à jour des fonctionnalités, l'événement \"Points VIP\" sera bientôt supprimé.",
    "213dzgVipRule2" : "Veillez à utiliser les coupons obtenus lors de l'événement \"Points VIP\" avant qu'ils n'expirent.",
    "213dzgVipRule3" : "Heure de Fin : 19/08/2024 08:00:00 (UTC)",
    "213dzgVipRule4" : "Après l'événement, vous pouvez visiter le Centre de Membres Premium pour bénéficier de plus d'avantages :",
    "213dzgVipRule5" : "Terminez des quêtes pour gagner des points, qui peuvent être échangés contre des coupons, des objets en jeu et d'autres récompenses ! Profitez d'avantages exclusifs et de tirages chanceux.",
    "213dzgVipRule6" : "Restez à l'écoute pour plus de récompenses et d'événements !",
    "getReward" : "Exclusive avatar frames",
    "unbindEntry" : "Lier/Délier le Compte",
    "unbindApply" : "Délier",
    "unbindConfirmTitle" : "Êtes-vous sûr de vouloir délier votre compte ?",
    "unbindConfirmTip" : "Délier un compte peut entraîner la perte de sauvegarde/progression en jeu.",
    "unbindConfirm" : "Continuer de délier",
    "unbindExit" : "Quitter",
    "unbindSucc" : "Compte délié",
    "unbindFail" : "Déliaison de compte échouée. Merci de contacter le service clientèle.",
    "unbindServiceTitle" : "Veuillez demander une déliaison manuelle.",
    "unbindContact" : "Service clientèle",
    "unbindServiceTip" : "Déliaison de votre compte impossible. Merci de contacter le service clientèle.",
    "antslgType15" : "Héritage",
    "shareEventTitle" : "Inviter des Amis</br>Gagner des Récompenses",
    "shareRule" : "Règles",
    "awardBag" : "Ma Récompense",
    "initiatorText" : "Je suis un Invitant",
    "inviteeText" : "Je suis un Invité",
    "createCode" : "Créer un Code d\'Invitation",
    "createCodeTip" : "Appuyer pour créer un code d\'invitation",
    "createLinkTip" : "Appuyer pour créer un lien d\'invitation",
    "copyText" : "Copier",
    "shareCode" : "Partager le Code d\'Invitation",
    "twShare" : "",
    "fbShare" : "",
    "dcShare" : "",
    "seeAward" : "Afficher la Récompense",
    "seeAwardTip" : "Veuillez vérifier vos récompenses dans <span class=\"see-light\">Point VIP</span> > <span class=\"see-light\">Mon Coupon</span>.",
    "inviteReward" : "Récompense d\'Invitation",
    "inviteRewardTip" : "L\'invité ne peut réclamer ces récompenses que lorsque chaque invité atteint ces objectifs pour la première fois",
    "overweightReward" : "Récompense Bonus",
    "resetTip" : "Réinitialisation à 00h00 le dernier jour de chaque mois.（UTC+0）",
    "rewardText1" : "Recharge Total par l\'Invité : 9.99 \$",
    "rewardText2" : "Recharge Total par l\'Invité : 49,99 \$",
    "rewardText3" : "Recharge Total par l\'Invité : 99.99 \$",
    "rewardText4" : "Obtenez Coupon 12% de Réduction x1 pour Chaque 5 Joueurs Invités",
    "rewardText5" : "Obtenez Coupon 15% de Réduction x1 Après que Vos Invités Aient Rechargé un Total de 1 000 \$",
    "invitationList" : "Mon Invitation",
    "refresh" : "Actualiser",
    "invitedTotal" : "Invité : \${total}",
    "storedTotal" : "Recharge Totale : \${total} USD",
    "people" : "",
    "invitedPeople" : "Invité",
    "invitedTime" : "Invité",
    "got" : "Atteint",
    "get" : "Non Atteint",
    "overlay" : "Cumulable",
    "couponText" : "Coupon",
    "personalReward" : "Récompense de Recharge",
    "personalRewardText1" : "Le Total de Recharge atteint 9,99 \$",
    "personalRewardText2" : "Le Total de Recharge atteint 49,99 \$",
    "personalRewardText3" : "Le Total de Recharge atteint 99,99 \$",
    "inputCode" : "Saisir le Code d\'Invitation",
    "bindCode" : "Confirmer",
    "bindSucc" : "Lié",
    "codeTip1" : "Le code n\'existe pas.",
    "codeTip2" : "Code d\'Invitation Lié",
    "copySucc" : "Succès !",
    "awardName" : "Récompense",
    "getTime" : "Obtenu",
    "getCondition" : "Exigence",
    "couponText1" : "Coupon 6% de Réduction",
    "couponText2" : "Coupon 8% de Réduction",
    "couponText3" : "Coupon 10% de Réduction",
    "couponText4" : "Coupon 12% de Réduction",
    "couponText5" : "Coupon 15% de Réduction",
    "ruleText1" : "1. Heure de début de l\'événement : 25/11/2022, 00:00 UTC",
    "ruleText2" : "2. Jeu de l\'événement : Puzzles & Survival",
    "ruleText3" : "3. Événement \"Partage du Site Officiel de Recharge\" : Partagez ce site officiel de recharge avec vos amis et invitez-les à recharger. S\'ils rechargent un certain montant via cette page, vous serez récompensé.",
    "ruleText4" : "4. Récompenses Mensuelles provenant d\'un paiement tiers : Atteignez les objectifs mensuels de partage pour gagner des récompenses. Les récompenses de partage sont réinitialisées chaque mois.",
    "ruleText5" : "5. Les Récompenses Mensuelles nécessitent au moins un paiement réussi sur le site tiers par les nouveaux joueurs que vous avez invités.",
    "ruleText6" : "6. Les récompenses mensuelles sont réinitialisées le premier jour de chaque mois. Cela remet également à zéro toute progression du mois précédent.",
    "ruleText7" : "7. Le coupon récompensé doit être réclamé en se connectant au site de recharge tiers. Vous ne recevrez pas de nouveau coupon s\'il a expiré.",
    "ruleText8" : "8. Le coupon utilise la même devise que celle que vous avez utilisée lors de vos précédentes recharges.",
    "ruleText9" : "9. Vous ne pouvez pas utiliser le code d\'invitation d’un autre joueur si il a déjà utilisé le votre.",
    "ruleTableTitle1" : "Règles：",
    "ruleTableTitle2" : "Paliers VIP et Coupons Expliqués :",
    "ruleTableHead1" : "Conditions de Recharge",
    "ruleTableHead2" : "Exigence des Récompenses",
    "ruleTableHead3" : "Récompenses",
    "ruleTableContent1" : "Invitez 5 nouveaux joueurs",
    "ruleTableContent2" : "Les joueurs invités rechargent 1 000 \$",
    "errorTip" : "Opération annulée",
    "eventShareText1" : "Offres en Temps Limité Puzzles & Survival",
    "eventShareText2" : "Pleins de Cadeaux à Gagner !",
    "cartDoubleTip" : "Les Multiplicateurs de Boîtes ne sont pas pris en charge.",
    "codeTip3" : "Non connecté",
    "codeTip4" : "Paramètres manquants",
    "codeTip5" : "Ne peut pas lier votre propre code d\'invitation",
    "codeTip6" : "Code d\'invitation créé",
    "payWelfare" : "Cadeau de Recharge",
    "wallet" : "Portefeuille",
    "myDiscount" : "Mon Coupon",
    "knowMore" : "Plus",
    "backPay" : "Retour",
    "curBalance" : "Solde",
    "pay" : "Recharger",
    "changeCoin" : "Changer de Monnaie",
    "watchDesc" : "Voir les Détails",
    "getMore" : "Obtenir Plus",
    "getDiscount" : "Réclamer Vos Coupons",
    "notOpenDiscountQuan" : "Aucun événement. Veuillez rester à l\'écoute !",
    "abountZbit" : "À propos de \${Z-BIT}",
    "remain" : "Restant :",
    "payRemain" : "Montant restant après l\'achat :",
    "payRemainExpiry" : "Solde estimé après paiement : ${money} (À utiliser avant le 01/01/26. Dépêchez-vous !)",
    "balanceNotEnoughExpiry" : "Solde insuffisant (Expire le 01/01/2026, non rechargeable)",
    "balanceNotEnoggh" : "Le solde n\'est pas suffisant. Veuillez d\'abord recharger.",
    "goToPay" : "Recharger",
    "chooseOtherPay" : "Autres Modes de Paiement",
    "payIntro" : "Détails de Recharge",
    "logRole" : "Sélectionner un Personnage",
    "chooseProduct" : "Sélectionner des Objets",
    "meAgree" : "J\'ai lu et accepté les conditions.",
    "coinAgreeText" : "",
    "aboutCoin" : "",
    "coinsPayTokenLogin" : "Une vérification dynamique est nécessaire avant d\'utiliser \${Z-BIT}",
    "dl3dvnVipRule1" : "1. Jeux disponibles : \${gameName}",
    "dl3dvnVipRule2" : "Chaque type de récompense de l\'événement ne peut être réclamé qu\'une seule fois.",
    "dl3dvnVipRule3" : "2. Événement Coupon de Connexion : en accédant à la page de recharge pour la première fois, vous pourrez réclamer un coupon de -15 %.",
    "dl3dvnVipRule4" : "3. Événement Points VIP : achetez un objet sur notre page officielle pour gagner des points et obtenir des coupons de niveau et des coupons hebdomadaires.",
    "dl3dvnVipRule5" : "4. Les points que vous pouvez gagner peuvent varier en fonction de la devise que vous utilisez. Pour plus de détails, veuillez consulter le lien en bas de page.",
    "dl3dvnVipRule6" : "5. Lorsque vous utilisez des coupons, vous gagnez des points sur la base du montant que vous avez payé après déduction des coupons.",
    "dl3dvnVipRule7" : "6. Les points que vous avez gagnés expireront dans 365 jours. Cela peut affecter votre niveau VIP.",
    "dl3dvnVipRule8" : "7. Vous recevrez immédiatement un coupon pour avoir atteint un niveau VIP pour la première fois. Le coupon hebdomadaire pourra être réclamé à 00:00 (UTC+0) chaque samedi.",
    "dl3dvnVipRule9" : "8. Vous devrez vous connecter pour réclamer le coupon hebdomadaire. Ne manquez pas cette occasion !",
    "dl3dvnVipRule10" : "9. La devise du coupon sera la devise de la dernière commande que vous avez effectuée. Veuillez contacter notre service clientèle si vous souhaitez changer la devise utilisée.",
    "dl3dvnVipRule11" : "10. Voir le tableau ci-dessous pour plus de détails sur les niveaux VIP et les coupons.",
    "dl3dvnVipRule12" : "",
    "dl3dvnVipRule13" : "12. En cas de litige, l\'équipe d\'assistance de \${gameName} a la seule et dernière discrétion d\'interprétation des présentes conditions générales.",
    "codeTip7" : "Impossible d\'utiliser le code du joueur puisqu\'il l’a déjà utilisé",
    "ruleText10" : "10. La direction officielle de Puzzles & Survival se réserve tout droit d\'interprétation finale.",
    "payCoins" : "Recharge de Points VIP",
    "shareGift" : "Partager pour des Cadeaux",
    "attentionCoinUse" : "Note: The balance in each currency is handled separately.",
    "noPayWay" : "Aucune méthode de paiement n\'est disponible dans la région sélectionnée. Veuillez changer de région et réessayer.",
    "dl3dtwVipRule1" : "1. Jeux disponibles : \${gameName}",
    "dl3dtwVipRule2" : "Chaque type de récompense de l\'événement ne peut être réclamé qu\'une seule fois.",
    "dl3dtwVipRule3" : "2. Événement Points VIP : achetez un objet sur notre page officielle pour gagner des points et obtenir des coupons de niveau et des coupons hebdomadaires.",
    "dl3dtwVipRule4" : "3. Les points que vous pouvez gagner peuvent varier en fonction de la devise que vous utilisez. Pour plus de détails, veuillez consulter le lien en bas de page.",
    "dl3dtwVipRule5" : "4. Lorsque vous utilisez des coupons, vous gagnez des points sur la base du montant que vous avez payé après déduction des coupons.",
    "dl3dtwVipRule6" : "5. Les points que vous avez gagnés expireront dans 365 jours. Cela peut affecter votre niveau VIP.",
    "dl3dtwVipRule7" : "6. Vous recevrez immédiatement un coupon pour avoir atteint un niveau VIP pour la première fois. Le coupon hebdomadaire pourra être réclamé à 00:00 (UTC+0) chaque samedi.",
    "dl3dtwVipRule8" : "7. Vous devrez vous connecter pour réclamer le coupon hebdomadaire. Ne manquez pas cette occasion !",
    "dl3dtwVipRule9" : "8. La devise du coupon sera la devise de la dernière commande que vous avez effectuée. Veuillez contacter notre service clientèle si vous souhaitez changer la devise utilisée.",
    "dl3dtwVipRule10" : "9. Voir le tableau ci-dessous pour plus de détails sur les niveaux VIP et les coupons.",
    "dl3dtwVipRule11" : "10. En cas de litige, l\'équipe d\'assistance de \${gameName} a la seule et dernière discrétion d\'interprétation des présentes conditions générales.",
    "eventInviteSucc" : "Invitation d’Amis Réussie",
    "eventGainCondition" : "Conditions",
    "eventSuccInvite" : "Invitation d’amis réussie",
    "eventInviteGainOne" : "Recharge Totale\npar l\'Invité : 49,99 \$",
    "eventInviteGainTwo" : "Recharge Totale \npar l\'Invité : 99.99 \$",
    "eventFriendCode" : "Votre Code d’Amis :",
    "eventCheckBind" : "Lier ?",
    "eventConfirm" : "Confirmer",
    "eventCancel" : "Annuler",
    "eventBindSucc" : "Lié avec succès !",
    "eventGainCoupon" : "Vous avez obtenu un coupon.",
    "eventLookCoupon" : "Voir le Coupon",
    "eventSuccBind" : "Lié avec succès",
    "recaptchaTip" : "Veuillez vérifier d\'abord",
    "completeRecaptcha" : "Veuillez terminer la vérification captcha",
    "recaptchaExpired" : "La vérification a expiré, veuillez réessayer",
    "inputAccountName" : "Veuillez entrer le compte que vous souhaitez récupérer",
    "pwaPayTip" : "Accès Rapide, Meilleure Expérience",
    "pwsInstall" : "Ajouter à l\'Écran d\'Accueil",
    "ztmslgType999" : "Coupon",
    "coinUseTips" : "После покупки Ваучеры будут отправлены на вашу игровую почту. Ваучеры можно использовать для покупки предметов в Магазине ваучеров. Ваучеры, использованные для покупки предметов, будут учитываться в общее пополнение счёта.",
    "notice" : "Avis",
    "popupConfirm" : "Confirmer",
    "hideWithinWeek" : "Ne plus afficher pendant 7 jours",
    "ztmslgProductOffTips" : "Nous avons reçu de nombreux commentaires concernant les modifications de la page de paiement qui devaient être implémentées le 13 Mars. En réponse à cela, nous avons décidé d\'annuler ces changements et nous nous concentrerons sur l\'amélioration de votre expérience d\'achat. Nous apprécions vos avis et vous remercions de votre compréhension et de votre soutien. Si vous avez d\'autres questions, n\'hésitez pas à contacter notre Équipe de Support Client.",
    "couponTopLimit" : "Montants Maximaux des Déductions par Devise",
    "swsjpVipRule1" : "1. L\'événement commence à 00:00 (UTC) le 2023/03/24",
    "swsjpVipRule2" : "2. Jeux disponibles : \${gameName}",
    "swsjpVipRule3" : "Chaque type de récompense de l\'événement ne peut être réclamé qu\'une seule fois.",
    "swsjpVipRule4" : "3. Événement Coupon de Connexion : en accédant à la page de recharge pour la première fois, vous pourrez réclamer un coupon de -15 %.",
    "swsjpVipRule5" : "4. Événement Points VIP : achetez un objet sur notre page officielle pour gagner des points et obtenir des coupons de niveau et des coupons hebdomadaires.",
    "swsjpVipRule6" : "5. Les points que vous pouvez gagner peuvent varier en fonction de la devise que vous utilisez. Pour plus de détails, veuillez consulter le lien en bas de page.",
    "swsjpVipRule7" : "6. Lorsque vous utilisez des coupons, vous gagnez des points sur la base du montant que vous avez payé après déduction des coupons.",
    "swsjpVipRule8" : "7. Des points vous sont déjà accordés pour les achats que vous avez effectués précédemment.",
    "swsjpVipRule9" : "8. Les points que vous avez gagnés expireront dans 365 jours. Cela peut affecter votre niveau VIP.",
    "swsjpVipRule10" : "9. Vous recevrez immédiatement un coupon pour avoir atteint un niveau VIP pour la première fois. Le coupon hebdomadaire pourra être réclamé à 00:00 (UTC+0) chaque samedi.",
    "swsjpVipRule11" : "10. Vous devrez vous connecter pour réclamer le coupon hebdomadaire. Ne manquez pas cette occasion !",
    "swsjpVipRule12" : "11. La devise du coupon sera la devise de la dernière commande que vous avez effectuée. Veuillez contacter notre service clientèle si vous souhaitez changer la devise utilisée.",
    "swsjpVipRule13" : "12. En cas de litige, l\'équipe d\'assistance de \${gameName} a la seule et dernière discrétion d\'interprétation des présentes conditions générales.",
    "beautyVipRule1" : "",
    "beautyVipRule2" : "",
    "beautyVipRule3" : "",
    "beautyVipRule4" : "",
    "beautyVipRule5" : "",
    "beautyVipRule6" : "",
    "beautyVipRule7" : "",
    "beautyVipRule8" : "",
    "beautyVipRule9" : "",
    "beautyVipRule10" : "",
    "beautyVipRule11" : "",
    "antslgType999" : "Coupon",
    "passAskMods" : "Demander au Modérateur",
    "passAskModsTip" : "Posez aux Modérateurs toutes les questions concernant le jeu",
    "passService" : "Requête Client",
    "passServiceTip" : "Pour toute question concernant le compte et la recharge, veuillez contacter notre service clientèle.",
    "passIKonw" : "OK",
    "passGoOn" : "Continuer",
    "voucherTitle" : "Centre de Recharge Officiel",
    "voucherAddHome" : "Ajouter au Bureau",
    "voucherAddHomeTipOne" : "Paiement plus Rapide, Meilleure Expérience",
    "voucherAddHomeTipTwo" : "dans la barre d\'outils",
    "voucherAddHomeTipThree" : "Sélectionner [Ajouter au Bureau]",
    "voucherLoginLook" : "Se connecter pour voir les offres",
    "voucherSwitchRole" : "Changer de Personnage",
    "voucherCoupon" : "Coupon",
    "voucherVip" : "Points VIP",
    "voucherMoreCoupon" : "Plus d’Offres",
    "voucherAccountId" : "ID du Compte",
    "voucherOtp" : "OTP",
    "voucherOtherWayPay" : "Choisir un autre mode de paiement",
    "voucherOtherLoginWay" : "Essayer une autre méthode",
    "voucherCouponActivity" : "Offres en Réduction",
    "voucherActivityNotBegin" : "L’événement n’a pas encore commencé.",
    "voucherGoCommunity" : "En savoir plus sur les bénéfices de recharge dans la communauté",
    "voucherValidTime" : "Validité",
    "voucherLimitRegion" : "Pour \${currency} seulement",
    "voucherLiuyi" : "Pas de coupons disponibles. Veuillez prêter attention aux événements futurs.",
    "voucherPay" : "Acheter des Coupons",
    "voucherAbout" : "Info de Coupon",
    "voucherChooseWay" : "Sélectionner une Méthode de Paiement",
    "voucherMoreWay" : "Plus de Méthodes de Paiement",
    "voucherChooseCoupon" : "Sélectionner un Coupon",
    "voucherHasChoose" : "Sélectionné",
    "voucherMoneyInsufficient" : "Solde insuffisant",
    "voucherContact" : "Solde insuffisant. Veuillez contacter notre équipe support.",
    "voucherCouponTotal" : "Coupons Disponibles",
    "voucherCouponTipGuide" : "Les coupons peuvent être utilisés pour le paiement après avoir sélectionné le canal de paiement.",
    "voucherPaytypeNotSupport" : "Les coupons ne sont pas disponibles pour ce canal de paiement",
    "voucherTipSideOne" : "Les coupons peuvent être échangés contre tous les packs du jeu et les services à valeur ajoutée, à l\'exception du coupon lui-même.",
    "voucherTipSideTwo" : "Jusqu’à -15% de réduction",
    "voucherYue" : "Solde",
    "jpUidLoginName" : "",
    "jpUidToken" : "",
    "jpUidInputToken" : "",
    "pnsBook" : "Manuel de Survie",
    "vipHeadText" : "Cadre exclusif VIP débloqué",
    "vipHeadGetText" : "Réclamer",
    "vipHeadGotText" : "Réclamé",
    "vipHeadGetTitle" : "Confirmer",
    "vipHeadGetTip" : "Cette récompense ne peut être réclamé qu\'une fois par compte. Continuer ?",
    "vipHeadAwardText" : "Commandant d\'Élite (Permanent)",
    "vipHeadGetErrTip1" : "Échec. Veuillez prendre contact avec le support.",
    "cartGuideTipNew" : "Füge weitere Items hinzu, um den Coupon zu verwenden.",
    "newVipTitle" : "Centre de Recharge VIP",
    "newVipLogin" : "SE CONNECTER",
    "newVipNowPoint" : "Points :",
    "newVipNextLevel" : "\${point} points pour le niveau suivant",
    "newVipUpgrade" : "AMÉLIORER",
    "newVipLevel" : "Privilèges VIP",
    "newVipTip" : "Les coupons seront mis à jour à 00h00 (UTC) tous les samedis. Vous les recevrez lorsque vous vous connecterez sur la page de recharge officielle.",
    "newVipWeekly" : "Cadeau Hebdomadaire",
    "newVipReachPoint" : "Exigences :",
    "newVipRuleInfo" : "Règles :",
    "pleaseLang" : "Choisissez une langue",
    "reference" : "Numéro de commande",
    "saveToNext" : "Enregistrez les informations relatives à la carte de crédit.",
    "cardNum" : "Numéro de carte",
    "expireTime" : "Valable par",
    "CVV" : "CVV",
    "pleaseCard" : "Type de carte de crédit",
    "howToPay" : "Comment souhaitez-vous payer ?",
    "checkCard" : "Veuillez vérifier le numéro de votre carte.",
    "checkExpiryDate" : "Vérifiez la date d\'expiration de votre carte.",
    "checkCVV" : "Vérifiez le CVV de votre carte.",
    "addCard" : "Nouveau",
    "delete" : "Effacer",
    "deleteCardTips" : "Supprimer les informations enregistrées sur la carte de crédit.",
    "confirmDelete" : "Oui, supprimer",
    "cancelDelete" : "Annuler",
    "checkAllCardMsg" : "Assurez-vous d\'avoir saisi le bon numéro de carte, la bonne date d\'expiration et le bon CVV.",
    "leaveCreditPageTips" : "Thoát trang sẽ khiến giao dịch thanh toán thất bại, xác nhận thoát ra?",
    "sureToLeave" : "Xác Nhận",
    "continueToPay" : "Thanh Toán Tiếp",
    "pushTest" : "Test de Notification",
    "getNoticication" : "Vous ne recevez pas les notifications du jeu ?",
    "waitCheckResult" : "Veuillez attendre le résultat du test.",
    "hadAbnormal" : "Une anomalie susceptible d\'entraîner un échec de la notification a été détectée.",
    "clickIntro" : "Appuyez sur le rapport pour voir la solution",
    "networkCheck" : "Test de réseau",
    "noticeAuthorityCheck" : "Test d\'accès aux notifications",
    "noticeBtnCheck" : "Test de la barre de notification",
    "gmsCheck" : "Test du service GMS",
    "batteryCheck" : "Test de la liste d\'optimisation de la batterie",
    "pushServiceCheck" : "Test du service de notification",
    "reCheck" : "Recommencer le test",
    "noNoticeAuthorityTip" : "L\'accès aux notifications n\'est pas autorisé sur cet appareil. Allez dans Paramètres système - Notifications pour autoriser l\'accès au jeu.",
    "noNoticeBtnTip" : "La barre de notification est désactivée. Veuillez l\'activer dans les paramètres du système.",
    "noBatteryTip" : "Le jeu est sur la liste d\'optimisation de la batterie, il se peut que vous ne receviez pas les notifications. Allez dans Paramètres système - Batterie - Optimisation de la batterie pour ajouter le jeu à la liste blanche.",
    "noPushServiceTip" : "Le serveur de notification n\'est pas connecté. Tapez sur [Connecter] pour reprendre le service.",
    "noNetworkTip" : "Votre connexion réseau actuelle est instable.",
    "noGmsTip" : "Votre appareil ne prend pas en charge GMS. Veuillez utiliser un appareil compatible avec GMS.",
    "pushConnectFail" : "Serveur de notification déconnecté.",
    "pushConnectSucc" : "Serveur de notification connecté.",
    "noGetPushTitle" : "Si vous ne pouvez toujours pas recevoir de notification du jeu. Veuillez suivre les étapes suivantes :",
    "noGetPushContOne" : "1. Déconnectez-vous du jeu et reconnectez-vous sur cet appareil.",
    "noGetPushContTwo" : "2. Appuyez sur [Test de notification] pour vérifier si votre appareil en cours d\'utilisation peut recevoir la notification de test.",
    "noGetPushContThree" : "3. Si vous avez reçu la notification de test mais que vous ne pouvez toujours pas recevoir d\'autres notifications, connectez-vous au jeu, allez dans Paramètres - Notifications et vérifiez si toutes les notifications sont activées.",
    "noGetPushContFour" : "4. Si vous ne pouvez toujours pas recevoir de notifications, contactez notre service clientèle.",
    "getPushSucc" : "Votre appareil a reçu une notification test. La fonction fonctionne normalement !",
    "allCheckSucc" : "Test de notification effectué. Aucune anomalie n\'a été détectée !",
    "pushCheck" : "Test de notification",
    "useDirectPay" : "Utiliser Achat Express",
    "paypalFraudnetInfo" : "Paiement sécurisé via PayPal",
    "goToSetting" : "Paramètres",
    "retry" : "Réessayer",
    "connect" : "Se connecter",
    "canRebind" : "Vous pouvez vous lier à nouveau après vous être délié",
    "agreePlatform" : "J\'ai accepté le \${service} et le \${privite}.",
    "sendGameNews" : "S\'abonner aux bulletins d\'information.",
    "canNotBindEmail" : "Vous ne pourrez pas utiliser cet e-mail pour vous connecter une fois que vous l\'aurez délié.",
    "canNotBindPhone" : "Vous ne pourrez pas utiliser ce numéro de téléphone portable pour vous connecter une fois que vous l\'aurez délié.",
    "canChangeByEmail" : "Vous pouvez vous connecter par e-mail sur différents appareils.",
    "canChangeByPhone" : "Vous pouvez vous connecter avec votre numéro de téléphone portable sur différents appareils.",
    "loginSucc" : "Connecté",
    "phoneHadBind" : "Le numéro de téléphone portable a déjà été lié. Se connecter avec ?",
    "emailHadBind" : "L\'adresse e-mail a déjà été liée. Se connecter avec ?",
    "phoneNotBind" : "Le numéro de téléphone portable n\'a pas encore été lié. Créer un nouveau compte ?",
    "emailNotBind" : "L\'adresse électronique n\'a pas encore été liée. Créer un nouveau compte ?",
    "emailAccount" : "Compte e-mail",
    "phoneAccount" : "Compte de téléphone portable",
    "phoneInputError" : "Numéro de téléphone portable non valide",
    "registerNewAccount" : "S\'inscrire",
    "secureTip" : "Conseils de Sécurité pour les Comptes",
    "toTop" : "Épingler en haut",
    "createNewWork" : "Nouveau Ticket",
    "serviceEvaluate" : "Noter le service",
    "emailRemind" : "Notifications",
    "isAgreeService" : "Comment trouvez-vous notre service ?",
    "thankEvaluateTop" : "Merci de nous faire part de vos commentaires !",
    "inputValidEmail" : "Veuillez saisir une adresse e-mail valide.",
    "replyWillRemind" : "Vous recevrez un e-mail de notification lorsque la réponse à votre question sera disponible. Appuyez à nouveau pour le désactiver.",
    "isCancelEmailRemind" : "Vous ne recevrez pas d\'e-mail de notification. Toujours désactivé ?",
    "reconfirmEmail" : "Veuillez confirmer votre adresse e-mail.",
    "confirmCanSubmit" : "Confirmer l\'envoi du ticket",
    "serviceWillReply" : "Vous serez informé par e-mail de la réponse du service clientèle.",
    "cancelEmailRemind" : "Désactiver [Notifications] ?",
    "yes" : "Oui",
    "no" : "Non",
    "inputWorkSearch" : "Recherche...",
    "loading" : "Chargement",
    "loadingError" : "Chargement échoué. Veuillez charger à nouveau...",
    "noMore" : "Rien de plus",
    "cancelToTop" : "Ne plus épingler",
    "evaluateOne" : "Très mauvais",
    "evaluateTwo" : "Mauvais",
    "evaluateThree" : "Neutre",
    "evaluateFour" : "Bien",
    "evaluateFive" : "Très bien",
    "confirmDelWorkTop" : "Supprimer ce ticket ?",
    "reRemindEmail" : "Besoin d\'une notification par e-mail ? Appuyez à nouveau sur le bouton [Notifications].",
    "confirmWillReply" : "Confirmez que vous acceptez d\'être informé par e-mail de la réponse du service clientèle.",
    "thankEvaluateBottom" : "",
    "confirmDelWorkBottom" : "Un ticket supprimé ne peut pas être restauré.",
    "morePurchaseWay" : "",
    "purchaseNeed" : "",
    "videoUploadSucc" : "Vidéo téléchargée",
    "videoUploadFail" : "Échec du téléchargement de la vidéo",
    "videoUploadLimit" : "Veuillez télécharger un fichier mp4 d\'une taille inférieure à 400 Mo et d\'une durée maximale de 2 minutes.",
    "imageUploadSucc" : "Image téléchargée",
    "imageUploadFail" : "Échec du téléchargement de l\'image",
    "uploading" : "Téléchargement",
    "smartOrderCreate" : "Ticket Rapide",
    "smartOrderSearch" : "Recherche",
    "smartOrderComing" : "Bientôt Disponible",
    "smartOrderContactService" : "Service Clientèle",
    "smartOrderDetector" : "Assistant",
    "smartOrderDetect" : "Diagnostic",
    "smartOrderDetecting" : "Diagnostiquer",
    "smartOrderDetectTip" : "Un problème a été détecté pendant que vous jouez. Veuillez appuyer sur Diagnostiquer pour que nous puissions l\'identifier.",
    "smartOrderDetectTip2" : "Problème identifié. Veuillez soumettre un ticket afin que nous puissions le résoudre pour vous !",
    "smartOrderSubmit" : "Soumettre",
    "smartOrderIKnow" : "OK",
    "smartOrderConfirm" : "OK",
    "smartOrderLook" : "Voir",
    "smartOrderIsHelp" : "Cet article a-t-il été utile ?",
    "smartOrderInputQuestion" : "Notez le problème que vous avez rencontré.",
    "smartOrderPleaseInpt" : "Saisir",
    "smartOrderPleaseChoose" : "Sélectionner",
    "smartOrderStoreTime" : "Heure de Recharge",
    "smartOrderInputOrder" : "Veuillez insérer un numéro de commande",
    "smartOrderInputPrice" : "Veuillez insérer un montant de commande",
    "smartOrderNeedHelp" : "Comment puis-je vous aider ?",
    "smartOrderLookHelpTip" : "Vous devriez regarder la FAQ.",
    "smartOrderNoResult" : "Aucun résultat. Veuillez essayer un autre mot-clé.",
    "smartOrderUpdateTime" : "Heure de dernière modification",
    "smartOrderSelectStoreTime" : "Choisir l\'heure de Recharge",
    "smartOrderAtlestChoose" : "Veuillez au moins en choisir un",
    "pwaInstallAward" : "Ajouter un Raccourci",
    "getMasonry" : "Réclamer des Diamants",
    "addToDrawerVisit" : "Ajoutez un raccourci pour pouvoir le retrouver facilement.",
    "immeAddToGet" : "Ajoutez un raccourci maintenant pour bénéficier de récompenses limitées.",
    "add" : "Ajouter un Raccourci",
    "talkNextTime" : "Plus tard",
    "chooseRoleGetGift" : "Sélectionner votre personnage pour obtenir des récompenses",
    "getGiftSuccess" : "Réclamé. Allez vérifier vos récompenses en jeu.",
    "dmaTitle" : "Publicités personnalisées",
    "dmaTitleSub" : "(facultatif)",
    "newAdd" : "Nouveau",
    "smartDelete" : "Effacer",
    "wordLengthTip" : "(0-600 caractères)",
    "areaLimitSwitchRegion" : "Changer de Région",
    "areaLimitCurrentRegionCurrency" : "Région et Devise Actuelle",
    "areaLimitRegion" : "Région :",
    "areaLimitCurrency" : "Devise :",
    "areaLimitNote" : "Note :",
    "areaLimitSwitchLimitation" : "Chaque compte ne peut changer de région qu\'une fois par an.",
    "areaLimitPostSwitchCoupon" : "Une fois que votre région aura changé, la devise des nouveaux coupons sera modifiée en conséquence.",
    "areaLimitRemainingSwitches" : "Chances de changement restantes : \${times}",
    "areaLimitNoRemainingSwitches" : "Aucune chance de changement",
    "areaLimitUnableToSwitchThisYear" : "Vous ne pouvez pas changer de région cette année.",
    "areaLimitCannotSwitch" : "Impossible de Changer",
    "areaLimitNavigateToSwitch" : "Changer",
    "areaLimitConfirmSwitch" : "Confirmer",
    "areaLimitPreSwitchRegionCurrency" : "Région et Devise Actuelle",
    "areaLimitPostSwitchRegionCurrency" : "Nouvelle Région et Devise",
    "areaLimitPostSwitchRestriction" : "Une fois effectué, vous ne pouvez plus changer de région cette année.",
    "areaLimitUnusedZBitWarning" : "Vous avez des Z-Bit inutilisés qui ne pourront plus être utilisés une fois que vous aurez changé de région. Continuer ?",
    "areaLimitConfirm" : "Confirmer",
    "areaLimitCancel" : "Annuler",
    "areaLimitInconsistencyWarning" : "Votre région d\'accès est incompatible avec votre région de paiement.",
    "areaLimitPromptToSwitch" : "Voulez-vous changer de région ?",
    "areaLimitEnterZipCode" : "*Please enter your zipcode",
    "areaLimitEnterInvalid" : "Zipcode is invalid, please re-enter",
    "areaLimitTaxRateTips" : "Depending on your location, the tax rate may vary, the payment amount shall prevail",
    "areaLimitInfoCollect" : "For information collection protection, please refer to the Privacy Policy",
    "getAward" : "Réclamer une Récompense",
    "selectProductTitle" : "Choisir un Objet",
    "hotSuggest" : "Top",
    "inputKeywordSearch" : "Recherche...",
    "lookProductContent" : "Détails",
    "popupClose" : "Fermer",
    "productSwitch" : "Changer",
    "confirmBuy" : "Acheter",
    "thinkLater" : "Plus tard",
    "areaLimitConfirmRegion" : "Confirmer la région",
    "areaLimitContinuePay" : "Continuer à payer",
    "areaLimitSwitchLimitationTwice" : "Chaque compte peut changer de région deux fois par an.",
    "dtmslgVipRule1" : "1. Jeux disponibles : \${gameName}",
    "dtmslgVipRule2" : "Chaque type de récompense de l\'événement ne peut être réclamé qu\'une seule fois.",
    "dtmslgVipRule3" : "2. Événement Points VIP : achetez un objet sur notre page officielle pour gagner des points et obtenir des coupons de niveau et des coupons hebdomadaires.",
    "dtmslgVipRule4" : "3. Les points que vous pouvez gagner peuvent varier en fonction de la devise que vous utilisez. Pour plus de détails, veuillez consulter le lien en bas de page.",
    "dtmslgVipRule5" : "4. Lorsque vous utilisez des coupons, vous gagnez des points sur la base du montant que vous avez payé après déduction des coupons.",
    "dtmslgVipRule6" : "5. Les points que vous avez gagnés expireront dans 365 jours. Cela peut affecter votre niveau VIP.",
    "dtmslgVipRule7" : "6. Vous recevrez immédiatement un coupon pour avoir atteint un niveau VIP pour la première fois. Le coupon hebdomadaire pourra être réclamé à 00:00 (UTC+0) chaque samedi.",
    "dtmslgVipRule8" : "7. Vous devrez vous connecter pour réclamer le coupon hebdomadaire. Ne manquez pas cette occasion !",
    "dtmslgVipRule9" : "8. La devise du coupon sera la devise de la dernière commande que vous avez effectuée. Veuillez contacter notre service clientèle si vous souhaitez changer la devise utilisée.",
    "dtmslgVipRule10" : "9. Voir le tableau ci-dessous pour plus de détails sur les niveaux VIP et les coupons.",
    "dtmslgVipRule11" : "10. En cas de litige, l\'équipe d\'assistance de \${gameName} a la seule et dernière discrétion d\'interprétation des présentes conditions générales.",
    "dtmslgType10010" : "SOLDES QUOTIDIENNES",
    "dtmslgType10020" : "OFFRE LIMITÉE",
    "dtmslgType10030" : "HÉROS",
    "dtmslgType10040" : "MATÉRIEL",
    "dtmslgType10050" : "RUNE",
    "dtmslgType10060" : "TOTEM",
    "dtmslgType10070" : "PIERRE SAINTE",
    "dtmslgType10080" : "DRAGON",
    "dtmslgType10090" : "RESSOURCES",
    "dtmslgType10100" : "CONSTRUCTION ET RECHERCHE",
    "dtmslgType10110" : "OBJETS RARES",
    "dtmslgType10120" : "Curiosité",
    "dtmslgType10130" : "DIAMANT",
    "dtmslgType10140" : "Coupon",
    "dtmslgType2" : "Pack Évènement",
    "dtmslgType3" : "Centre de récompense",
    "dtmslgType4" : "Pack Pop-Up",
    "dtmslgType5" : "Pack Écran principal",
    "dtmslgType20010" : "Pack Black Friday",
    "dtmslgType20021" : "Cadeau 5 jours",
    "dtmslgTypeother" : "Other",
    "rightsIntro" : "",
    "213RightsIntro": "En raison d'une mise à jour des fonctionnalités, l'événement \"Points VIP\" sera bientôt supprimé.<br/>\n" +
        "Veillez à utiliser les coupons obtenus lors de l'événement \"Points VIP\" avant qu'ils n'expirent.<br/>\n" +
        "Heure de Fin : 19/08/2024 08:00:00 (UTC)" +
        "Après l'événement, vous pouvez visiter le Centre de Membres Premium pour bénéficier de plus d'avantages :<br/>\n" +
        "Terminez des quêtes pour gagner des points, qui peuvent être échangés contre des coupons, des objets en jeu et d'autres récompenses ! Profitez d'avantages exclusifs et de tirages chanceux.<br/>\n" +
        "Restez à l'écoute pour plus de récompenses et d'événements !",
    "263RightsIntro": "En raison d'une mise à jour des fonctionnalités, l'événement \"Points VIP\" sera bientôt supprimé.<br/>\n" +
        "Veillez à utiliser les coupons obtenus lors de l'événement \"Points VIP\" avant qu'ils n'expirent.<br/>\n" +
        "Heure de Fin : 28/09/2024 00:00:00 (UTC)" +
        "Après l'événement, vous pouvez visiter le Centre de Membres Premium pour bénéficier de plus d'avantages :<br/>\n" +
        "Terminez des quêtes pour gagner des points, qui peuvent être échangés contre des coupons, des objets en jeu et d'autres récompenses ! Profitez d'avantages exclusifs et de tirages chanceux.<br/>\n" +
        "Restez à l'écoute pour plus de récompenses et d'événements !",
    "goToRights" : "Rendez-vous au Centre des Membres Premium",
    "oldVipIntro" : "Veillez à utiliser les coupons obtenus lors de l'événement \"Points VIP\" avant qu'ils n'expirent.",
    "pwa-20001" : "Veuillez d’abord vous connecter",
    "pwa-20002" : "Paramètre incorrect",
    "pwa-20003" : "Veuillez désigner un personnage",
    "pwa-20004" : "Envoi des récompenses échoué. Veuillez prendre contact avec le Service Client.",
    "pwa-20005" : "Vous avez déjà réclamé la récompense.",
    "pwa-20100" : "L\'événement n\'a pas commencé.",
    "pwa-20101" : "L\'événement est terminé.",
    "pwa-20102" : "Vous ne pouvez pas encore réclamer les récompenses.",
    "pwa-20103" : "Ödüllerinin süresi doldu.",
    "pwa-1001" : "Opération trop fréquente",
    "pwaCommon" : "Veuillez réessayer plus tard !",
    "zipCodeSwitchZipCode" : "Switch ZIP Code",
    "zipCodeState" : "state",
    "zipCodeRate" : "rate",
    "-" : "-",
    "officialStore": "Centre de Recharge Officiel",
    "headerSafeTip": "Sûr et sans risque Transaction instantanée",
    "safeChecking": "...en analysant l'environnement de paiement actuel",
    "safeChecked": "Sécurisé, utilisable en toute sécurité",
    "riskChecked": "Risque potentiel détecté, procéder avec prudence",
    "footerSafeTitle1": "Sûr",
    "footerSafeTitle2": "Pratique",
    "footerSafeTitle3": "Économique",
    "footerSafeTitle4": "Efficace",
    "footerSafeContent1": "Centre de Recharge Officiel",
    "footerSafeContent2": "Prend en charge plusieurs méthodes de paiement",
    "footerSafeContent3": "Offres de réduction, plus d'avantages en temps limité",
    "footerSafeContent4": "Transaction instantanée, sans délai",
    "limitedTimeActivityTitle" : "Avantages limités",
    "limitedTimeActivityTime" : "Durée de l’évènement :  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivityTaskProcess" : "(Actuellement \${curPay}/\${targetPay})",
    "limitedTimeActivityRateTips" : "(Le taux d’échange peut varier, veuillez consulter cette page pour des informations plus précises)",
    "limitedTimeActivityNotAchieve" : "Non terminé",
    "limitedTimeActivityClaim" : "Réclamer",
    "limitedTimeActivityClaimed" : "Réclamé",
    "limitedTimeActivityTimeLeft" : "Limité : \${days}j \${hours}h \${minutes}m \${seconds}s",
    "limitedTimeActivityRecord" : "Archives de réclamations",
    "limitedTimeActivityAward" : "Récompenses",
    "limitedTimeActivityGotTime" : "Nombre de réclamations",
    "limitedTimeActivityGotRole" : "Personnage réclamé",
    "limitedTimeActivityRule" : "Règles de l’évènement",
    "limitedTimeActivity285Rule1" : "1. Durée de l’évènement :  \${startDate} - \${endDate}（UTC）",
    "limitedTimeActivity285Rule2" : "2. Pendant l’évènement, vous devrez terminer des tâches dans un temps limité pour réclamer des récompenses. Les tâches sont catégorisées en tâches hebdomadaires et mensuelles :",
    "limitedTimeActivity285Rule3" : "(1) Tâches hebdomadaires : Chaque compte est limité à une tâche hebdomadaire à terminer par semaine, qui se réinitialise chaque lundi à minuit.",
    "limitedTimeActivity285Rule4" : "Tâche de connexion hebdomadaire : Dans le temps imparti, connectez-vous à la page de recharge officielle une fois.",
    "limitedTimeActivity285Rule5" : "Rechargez n’importe quelle quantité : Dans le temps imparti, rechargez n’importe quelle quantité sur le site officiel.",
    "limitedTimeActivity285Rule6" : "(2) Tâches mensuelles : Chaque compte est limité à une tâche mensuelle à terminer par mois, qui se réinitialise le 1er jour du mois à minuit.",
    "limitedTimeActivity285Rule7" : "Tâche de connexion : Dans le temps imparti, connectez-vous à la page de recharge officielle une fois.",
    "limitedTimeActivity285Rule8" : "Tâche de recharge cumulative : Dans le temps imparti, rechargez la quantité requise pour réclamer la récompense une fois.",
    "limitedTimeActivity285Rule9" : "Note : En raison de la lingue durée de l’évènement, le taux d’échange peut varier. Veuillez vous référer à la quantité de recharge affichée sur la page.",
    "limitedTimeActivity285Rule10" : "3. Sélectionnez un personnage avant de réclamer une récompense. Vous pourrez trouver vos récompenses en jeu une fois réclamées.",
    "limitedTimeActivityClaimAward" : "Récupérer la récompense",
    "limitedTimeActivityConfirmGot" : "Confirmer la réclamation",
    "limitedTimeActivityGetSucc" : "Réclamation réussie",
    "limitedTimeActivityGetFail" : "Échec de la réclamation. Veuillez réessayer plus tard ou contacter le service client.",
    "limitedTimeActivityFrequent" : "Veuillez éviter les actions répétées.",
    "limitedTimeActivityLoginFirst" : "Veuillez d’abord vous connecter.",
    "limitedTimeActivityWrongParam" : "Erreur de paramètre",
    "limitedTimeActivityOverTips" : "L’évènement a expiré. Veuillez actualiser la page.",
    "preRightsIntro" : "En raison d\'une mise à jour des fonctionnalités, l\'événement \"Points VIP\" sera bientôt supprimé.<br/>Heure de Fin : \${offLineDate}<br/>Veillez à utiliser les coupons obtenus lors de l\'événement \"Points VIP\" avant qu\'ils n\'expirent.<br/>Après l\'événement, vous pouvez visiter le Centre de Membres Premium pour bénéficier de plus d\'avantages :<br/>Terminez des quêtes pour gagner des points, qui peuvent être échangés contre des coupons, des objets en jeu et d\'autres récompenses ! Profitez d\'avantages exclusifs et de tirages chanceux.<br/>Restez à l\'écoute pour plus de récompenses et d\'événements !",
    "riskTipTitle" : "JAttention aux Comportements Illégaux et aux Escroqueries",
    "riskTipContent" : "Cher Joueur,\n\nNous avons remarqué que certains joueurs se livrent à des actions qui perturbent l\'ordre et l\'équité du jeu. Les violations les plus courantes sont les suivantes\n\n1. Publier des publicités non autorisées : Partager des publicités non autorisées via le chat du jeu ou d\'autres canaux, telles que la promotion d\'un commerce illégal de ressources ou de rechargements non autorisés.\n2. Utilisation de tricheries ou de scripts : Utiliser des tricheurs, des scripts ou d\'autres moyens techniques pour obtenir des ressources illégalement.\n3. Invitations non autorisées : Envoyer des invitations pendant le chat pour inciter les joueurs à entrer en contact par des canaux externes (par exemple, Line, Discord).\n4. Recharges illégales : Promouvoir des recharges non officielles à des prix réduits pour attirer les joueurs.\n5. Autres escroqueries : Se livrer à des activités frauduleuses, telles que l\'usurpation de l\'identité d\'un membre du personnel officiel.\n\nNous conseillons vivement à tous les joueurs de protéger leurs informations personnelles et leurs biens. Ne faites pas confiance aux messages illégaux ou liés à des escroqueries. Ces violations comportent des risques importants, notamment le risque de vol de compte ou d\'implication dans des activités frauduleuses. Veuillez noter que nous ne fournirons pas de compensation pour les pertes résultant de ces actions.\n\nPour les comptes surpris à adopter un tel comportement, nous prendrons des mesures appropriées en fonction de la gravité et de l\'impact des violations. Les mesures peuvent inclure, sans s\'y limiter, des avertissements, la confiscation des gains illégaux, des bannissements temporaires ou des bannissements permanents. Si vous constatez un comportement suspect en jeu, veuillez le signaler à notre équipe d\'assistance à la clientèle. Nous enquêterons dès que possible et prendrons les mesures nécessaires. Nous vous remercions de votre compréhension et de votre soutien.",
    "linkValid": "Ce lien a expiré",
    "-" : "-",
    "accountLabel": "Compte",
    "passwordLabel": "Mot de passe",
    "confirmPasswordLabel": "Confirmer le Mot de Passe",
    "confirmDeleteTitle" : "Êtes-vous sûr de vouloir supprimer votre compte et tous les personnages ?",
    "confirmDeleteYes" : "Oui, je souhaite supprimer mon compte et tous les personnages.",
    "selectGame" : "Sélectionner un Jeu",
    "confirmDeleteNo" : "Non. Je ne veux supprimer qu\'un personnage. Je souhaite conserver mon compte.",
    "delTermsTitle" : "Veuillez lire attentivement les conditions de suppression de compte et la notice.",
    "delCondTitle" : "1. Conditions de suppression de compte",
    "delCond1" : "(1) Veuillez vous connecter à votre compte avant de postuler. Si vous ne pouvez pas vous connecter, veuillez [récupérer votre compte d\'abord. Assurez-vous que le compte de jeu et le personnage vous appartiennent.",
    "delCond2" : "(2) Veuillez confirmer que votre compte et votre personnage ne présentent <span>aucun risque de sécurité</span>, y compris des plaintes, des rapports, des enquêtes, des arbitrages ou des poursuites judiciaires non résolus (déposés par ou contre vous).",
    "delCond3" : "(3) Veuillez confirmer que votre compte et votre personnage n\'ont <span>aucun paiement en suspens</span>, y compris des remboursements non résolus ou des abonnements actifs.",
    "delNoticeTitle" : "2. Avis de suppression de compte",
    "delNotice1" : "(1) La suppression de ce compte de jeu et de ses personnages associés sera <span>permanente et irréversible</span>.",
    "delNotice2" : "(2) Veuillez <span>régler tous les actifs en jeu</span>, y compris, mais sans s\'y limiter, les objets, la monnaie et les abonnements, avant de poursuivre, car ils seront définitivement supprimés lors de la suppression du compte. Aucun remboursement ne sera effectué après la fermeture du serveur de jeu pour les comptes ou les personnages supprimés.",
    "delNotice3" : "(3) La suppression des données des comptes et des personnages entraînera également la suppression ou l\'anonymisation de toutes les informations connexes. Toutefois, vous devrez dissocier et gérer manuellement les données associées aux connexions à des médias sociaux tiers (par exemple, Facebook).",
    "delNotice4" : "(4) Une période d\'attente de 14 jours (délai de réflexion) est prévue pour protéger vos intérêts (sauf si les réglementations locales diffèrent), au cours de laquelle vous pouvez contacter le service clientèle pour annuler la demande de suppression.",
    "delNotice5" : "(5) Si votre demande est acceptée, votre compte sera immédiatement gelé, mais la suppression des données peut prendre jusqu\'à une semaine. Vous recevrez une notification par e-mail à l\'issue de la procédure.",
    "delFormConfirm1" : "Je comprends les conditions et les conséquences de la suppression du compte.",
    "delFormConfirm2" : "Ce compte ne fait l\'objet d\'aucun rapport ou litige en suspens.",
    "delForm" : "J\'ai lu et j\'accepte <a class=\"account-delete-link\" href=\"javascript:;\">l\'Accord de résiliation de compte</a>.",
    "cannotDeleteMsgTitle" : "Impossible de supprimer le compte",
    "cannotDeleteMsg1" : "Votre compte ne remplit pas les conditions de suppression :",
    "cannotDeleteMsg2" : "Vous avez des tickets de support non résolus. Veuillez les résoudre avant de faire une nouvelle demande.",
    "cannotDeleteMsg3" : "Vous avez des remboursements en cours. Veuillez les régler avant de demander la suppression de votre compte.",
    "cannotDeleteMsg4" : "Votre compte est actuellement en cours d\'examen en raison de rapports de joueurs ou de plaintes. Veuillez attendre la fin de l\'examen avant de faire une nouvelle demande.",
    "formCompleted" : "Ticket soumis",
    "formCheckMsg1" : "Votre ticket a été soumis, veuillez attendre l\'examen et la réponse.",
    "formCheckMsg2" : "Vous pouvez vérifier l\'état d\'avancement du ticket dans <span class=\"account-delete-link\">[Mes Tickets]</span>.",
    "delEmailMsg1" : "Vous avertir par courriel après la suppression du compte ?",
    "delEmailMsg2" : "La suppression du compte prend environ une semaine en raison du traitement des données. Souhaitez-vous recevoir une notification par e-mail à l\'issue de la procédure ?",
    "delEmailMsg3" : "Votre adresse e-mail ne sera utilisée qu\'à des fins de notification.",
    "delEmailConfirmYes" : "Oui, veuillez m\'avertir par e-mail.",
    "delEmailFill" : "Veuillez saisir votre adresse e-mail de notification.",
    "delEmailConfirmNo" : "Non, je n\'ai pas besoin d\'être informé par e-mail.",
    "delCoolMsg1" : "Souhaitez-vous bénéficier d\'un délai de réflexion de 14 jours ?",
    "delCoolMsg2" : "Pendant le délai de réflexion de 14 jours, votre compte sera gelé, mais vous pouvez à tout moment demander l\'annulation de la suppression. Après 14 jours, si vous n\'avez pas annulé, votre compte sera supprimé et ne pourra pas être récupéré.",
    "delCoolMsg3" : "Si vous choisissez de ne pas bénéficier d\'un délai de réflexion, votre compte sera supprimé immédiatement après l\'introduction de la demande et ne pourra pas être récupéré.",
    "delCoolConfirmYes" : "Oui, je veux un délai de réflexion de 14 jours.",
    "delCoolConfirmNo" : "Non, supprimer maintenant.",
    "delSecondCheckMsg1" : "Êtes-vous sûr d\'avoir traité tout le contenu de votre compte et de vouloir activer le délai de réflexion ? Votre compte sera inaccessible après l\'activation.",
    "delSecondCheckConfirmYes" : "Oui, activez-le maintenant.",
    "delResMsg1" : "Votre demande de suppression de compte a été soumise et le compte suivant a été gelé :",
    "gameName" : "Nom en jeu :",
    "gameAccount" : "Compte de jeu :",
    "delResMsg2" : "<span>Veuillez faire une capture d\'écran et sauvegarder les informations de compte ci-dessus, car il s\'agit de la seule vérification possible si vous avez besoin de restaurer votre compte pendant la période de réflexion</span>.",
    "delResMsg3" : "Période de réflexion : 14 jours. Temps restant :",
    "delResMsg4" : "Pour annuler la demande de suppression pendant le délai de réflexion, cliquez sur [Contact Support].",
    "copyAccountInfo" : "Copier les informations du compte",
    "delResMsg5" : "Votre demande de suppression de compte a été traitée et votre compte est en cours de suppression. Vous ne pouvez donc plus vous y connecter.",
    "delResMsg6" : "La suppression d\'un compte prend un certain temps en raison de la grande quantité de données qu\'elle implique. Par conséquent, toutes les traces de votre compte ne seront pas effacées immédiatement. Nous prévoyons d\'achever ce processus dans un délai d\'environ une semaine.",
    "delResMsg7" : "Si vous avez précédemment fourni une adresse e-mail de notification, nous vous enverrons un e-mail à cette adresse.",
    "delResMsg8" : "Si vous souhaitez vous connecter à nouveau au jeu, vous pouvez créer un nouveau compte.",
    "appleOption" : "App Store",
    "googleOption" : "Google Play",
    "otherOption" : "Autres canaux",
    "itemWrong" : "Une erreur s\'est produite lors de votre saisie. Veuillez réessayer.",
    "delRegisterTime" : "Date d\'Enregistrement",
    "delDevice" : "Appareil Fréquemment Utilisé",
    "delIp" : "Adresse IP Fréquemment Utilisée",
    "delHistoryPayChannel" : "Canaux de recharge historiques",
    "delHistoryPayOrder" : "Numéros de Commande Antérieurs",
    "delDeleteReason" : "Raison de la Suppression du Compte",
    "delPrevStep" : "Précédent",
    "delNextStep" : "Suivant",
    "delSecondCheckMsg2" : "Êtes-vous sûr d\'avoir traité tout le contenu du compte et de procéder à la suppression du compte ? Une fois la suppression effectuée, votre compte ne sera plus accessible.",
    "pleaseFillIn" : "Veuillez fournir les informations suivantes",
    "switchNewVersion": "Passer à la Nouvelle",
    "switchNewVersionPlatform": "Plateforme de Paiement",
    "updateVersionPopupContent": "Pour garantir des performances de jeu fluides et le support des nouvelles fonctionnalités à venir, nous vous recommandons de mettre à jour le système de votre appareil afin de profiter d'une expérience de fonctionnement plus stable et d'une optimisation de la compatibilité.",
    selectTopupTips:"90 % des joueurs privilégient la recharge officielle.",
    chuzhi: "Recharger",
    selectMethods: "Méthode de paiement",
    landscapeTip2: "Veuillez faire pivoter votre téléphone en mode portrait pour une meilleure expérience",
    v3LaunchFromDesktopAndRewardToMailbox: 'Veuillez lancer depuis le bureau\nSélectionnez un personnage, la récompense sera envoyée par messagerie',
    ckoNotAvailable: 'Erreur du service de paiement, veuillez réessayer plus tard.',
    ckoSubmitFail: "Échec du paiement. Veuillez vérifier vos informations ou utiliser une autre carte. Si le montant a été débité, il sera remboursé sur le moyen de paiement d'origine.",
    gotoFinish: 'À faire',
    inAppPurchase: 'Achat in-app',
}